import * as React from "react";

const locales = {
  en: {
    AccessDenied: "Access denied",
    AccessRevoked: "Your access for {placeholder} has been revoked",
    Account: "Account",
    AccountDeactivated: "Account for {placeholder} has been deactivated. Please contact your administrator for assistance.",
    ActionFailed: "Action failed. Please try again later.",
    ActionSucceed: "Action succeeded!",
    Add: "Add",
    AddAttachment: "As attachments",
    AddEmail: "Add to Email",
    AddFiles: "Add files",
    AddFilesAdditional: "Add additional files",
    AddShareableLink: "As links",
    AdvancedSearch: "Advanced search",
    All: "All",
    AllAlt: "All",
    // Title case on purpose: parity with SharePoint's provisioned default view name
    // ("All Documents" / nl "Alle documenten" / de "Alle Dokumente") — this is the
    // view's NAME, not a sentence.
    AllDocuments: "All Documents",
    AllDocumentsCapReached: "Showing {placeholder} documents — the limit for this view. Later rows may be incomplete: some libraries were not read all the way down. Open a library, or use search or a filter, to see everything.",
    AllowApprovals: "Enable my approvals",
    AllowApprovalsMessage: "Enable Docubird to access your approvals information.",
    AlreadyAssigned: "Already assigned to this approver",
    AlreadyExists: "Already exists",
    AndSend: "and send",
    Anyone: "Anyone",
    App: "app",
    Appearance: "Appearance",
    Apply: "Apply",
    Approval: "Approval",
    ApprovalCenter: "Tasks",
    ApprovalRequestNotAllowedOwner: "The approval request may not be reassigned to the approval owner.",
    ApprovalsLoading: "Loading approvals...",
    ApprovalsShownHere: "Approvals will be shown here.",
    Approve: "Approve",
    Approvers: "Approvers",
    Ascending: "Ascending",
    AsPdf: "as Pdf",
    Attachments: "Attachments",
    AttachmentsSelected: "attachments selected",
    AttentionSaveModeActive: "Attention: please note that you are still in email save mode!",
    AutoFolderCreationNoContent: "Use the search field above to find documents and folders.",
    Automation: "Automation",
    AutomationFlowDescription: "Automation process description",
    AutomationFlowName: "Automation process name",
    AutomationFlowNotSelected: "No automation process selected",
    AutomationFlowRequest: "Automation request",
    AutomationFlowRequestError: "Automation request failed",
    AutomationFlowRequestSuccess: "Automation request successfully sent",
    AutoOpenDocubird: "Auto open Docubird for this document?",
    AutoRemoveMailItemAttachments: "Remove attachments on mail item save",
    AutoSelectAttachments: "Auto select attachments",
    AutoSetEmailProperty: "[Autoset to email property '{emailProperty}']",
    AvailableFiles: "Available files",
    Back: "Back",
    BackToWork: "Get Back To Work",
    Bcc: "Bcc",
    BlockDownload: "Block download",
    Browser: "browser",
    By: "by",
    Cancel: "Cancel",
    CancelApproval: "Cancel approval",
    CancelAssignment: "Cancel assignment",
    CancelAssignmentConfrimMessage: "Are you sure you want to cancel the assignment?",
    Cancelled: "Cancelled",
    CanEditMakesChanges: "Can edit - Make any changes",
    CanViewCannotMakeChanges: "Can view - Cannot make changes",
    Categories: "Categories",
    Cc: "Cc",
    Channels: "Channels",
    CheckedOutBy: "Checked out by",
    CheckedOutByYou: "You checked out this item",
    CheckIn: "Check in",
    CheckOut: "Check out",
    ChooseVersion: "Choose version",
    Clear: "Clear",
    ClearFilter: "Clear filter",
    ClearSearch: "Clear search",
    ClientGroup: "Client group",
    ClientGroupSitesCapped: "Showing documents from {0} of {1} client group sites",
    ClientGroupSearchPartial: "Some of the client group's sites could not be searched.",
    Columns: "Columns",
    ClipboardBlockedInstructions: "Clipboard access is blocked. Please allow clipboard access in your browser settings and try again, or copy the generated link(s) below manually.",
    Close: "Close",
    Comment: "Comment",
    Complete: "Complete",
    Confirm: "Confirm",
    ConfirmDeleteDocuments: "Are you sure you want to delete {placeholder} document(s)? They will be moved to the recycle bin.",
    ConfirmDeleteMailbox: "Are you sure you want to delete {mailbox}?",
    ConfirmPublish: "Do you want to publish?",
    ContactAdministrator: "Please contact your administrator for assistance.",
    ContactUs: "Please feel free to contact us for an appropriate quote.",
    ContentType: "Content Type",
    ContentTypes: "Content Types",
    Continue: "Continue",
    ConversationIndex: "Conversation-index",
    ConversationTopic: "Conversation-topic",
    ConvertEmailToPdf: 'Convert email to pdf on save',
    ConvertToPdf: 'Convert to PDF',
    Copied: "Copied",
    CopyAll: "Copy all",
    CopyingItems: "Copying items...",
    CopyItems: "Copy items",
    CopyLink: "Copy link",
    CopyProgress: "Copy progress",
    CopyProgressCounter: "{completed} of {total} items copied",
    CopyTo: "Copy to",
    Create: "Create",
    Created: "Created",
    CreateEmail: "Create Email",
    CreateEmailWithAttachment: "Create Email with attachment",
    CreateEmailWithLink: "Create Email with link",
    CreateWithAttachments: "With attachments",
    CreateWithShareableLinks: "With links",
    Datasource: "datasource",
    Date: "Date",
    Default: "Default",
    Delete: "Delete",
    DeleteSPItemConfirmMessage: "Are you sure you want to send this item(s) to the site recycle bin?",
    Deleting: "Deleting",
    Descending: "Descending",
    Description: "Description",
    DeselectAll: "Deselect all",
    Details: "Details",
    DiscardCheckOut: "Discard check out",
    Disconnect: "Disconnect",
    DocumentLibraries: "Document Libraries",
    DocumentLibrary: "Document library",
    DocumentSettings: "Document settings",
    DocumentSharedWithYouBy: "This is the document shared with you by [person].",
    DocumentSharedWithYouByEmailSubject: "[person] shared \"[file_name]\" with you.",
    DocumentShareSuccess: "\"[file_name]\" successfully shared.",
    Done: "Done",
    Download: "Download",
    DownloadAsPdf: "Download as pdf",
    DownloadAsPdfFailure: "Unable to convert the file to pdf format. The file might be an incorrect format, too large, or possibly corrupt.",
    DownloadFailure: "Download Failure",
    Downloading: "Downloading",
    DownloadingAttachments: "Downloading attachments",
    DoYouWantToCreateFolder: "Do you want to save the emails to a new folder?",
    Draft: "Draft",
    DueDate: "Due date",
    DueDateDescription: "Standard {days} days.",
    DuplicateResolved: "Your duplicate file names have been resolved. You can continue saving!",
    EditXItems: "Edit {itemCount} items",
    EmailHeaderMapping: "Email headers mapping",
    Emails: "Emails",
    Empty: "Empty",
    EmptyColumnHint: "(empty)",
    EnableEmails: "Enable emails",
    EnterDate: "Enter a date",
    EnterEmail: "Enter names, emails, or user groups",
    EnterFolderName: "Please enter a folder name",
    EnterLinkWebPageFile: "Enter the link to the webpage or file",
    EntireFolderSelected: "Entire folder selected",
    Error: "Error",
    ErrorConnectingToServer: "Error connecting to the server",
    ErrorDeletingFiles: "There was an error deleting one or more files",
    ErrorMessageGeneric: "Something went wrong",
    ErrorWhileUpdatingMetadata: "There was an error while updating your metadata",
    ExchangeSettings: "Exchange settings",
    ExternalContent: "External content",
    FetchProgressCounter: "{total} items fetched",
    FetchProgressCounterAll: "Fetching all items...",
    FieldRequired: "Field is required",
    FileBackgroundSave: "Your files are saving in the background...",
    FileBackgroundSaveFailure: "Something went wrong",
    FileCheckoutAndOpen: "Checkout and open",
    FileCheckoutAndOpenInBrowser: "Checkout and open in browser",
    FileCheckoutRequired: "This file must be checked out before changes can be made.",
    FileCount: "File count",
    FileCurrentlyCheckedOut: "This file is currently checked out",
    FileDeleted: "File not available",
    FileInfo: "File info",
    FileLocationError: "Cannot open file location.",
    FileLocationUnknown: "File location unknown",
    FileName: "File name",
    FileNotExist: "File does not exist anymore!",
    FileNotFound: "File not found",
    FileNotSaved: "Please ensure that your file has been locally saved!",
    FileOpenReadOnly: "Open as read-only",
    FileOpenReadOnlyInBrowser: "Open as read-only in browser",
    FilePlural: "file(s)",
    FileRecentlyDeleted: "The file has been deleted or moved, or you no longer have access to it",
    Files: "Files",
    FileSameCheckedOut: "A file with this name is already checked out",
    FileSameLocked: "A file with this name is locked",
    FileSameName: "A file with this name already exists",
    FileSaveSuccess: "Your files have been successfully saved",
    FileSaveSuccessSingle: "File successfully saved",
    FileSelected: "File selected",
    FilesNotSuccessfullyUploaded: "The following files were not successfully uploaded",
    FilesSelected: "Files selected",
    FilesSelectedToUpload: "file(s) selected to upload",
    FileVersionLimitReached: "File version limit reached",
    Filter: "Filter",
    FilterExcludesLibraries: "Hidden by the filter (column not present): {placeholder}",
    FilterDateStepIn30Days: "In 30 days",
    FilterDateStepIn3Months: "In 3 months",
    FilterDateStepIn3MonthsOrMore: "In 3 months or more",
    FilterDateStepIn7Days: "In 7 days",
    FilterDateStepInAYearOrMore: "In a year or more",
    FilterDateStepLast30Days: "In last 30 days",
    FilterDateStepLast3Months: "In the last 3 months",
    FilterDateStepLast7Days: "In last 7 days",
    FilterDateStepSince: "Since",
    FilterDateStepSinceYesterday: "Since yesterday",
    FilterDateStepToday: "Today",
    FilterDateStepTomorrow: "Tomorrow",
    FilterResults: "Filter results",
    Finalizing: "Finalizing",
    Finished: "All done",
    Folder: "Folder",
    FolderCreate: "Create new folder",
    FolderCreateSuccess: "The folder has been successfully created",
    FolderDeleted: "Folder not available",
    FolderName: "Folder name",
    FolderNotExist: "Folder does not exist anymore!",
    FolderRecentlyDeleted: "The folder has been deleted or moved, or you no longer have access to it",
    Folders: "Folders",
    FolderSameName: "A folder with this name already exists",
    FolderSameNameAutoRename: "A folder or folders with the same name(s) already exists. The uploaded folder(s) will be automatically renamed upon upload.",
    FolderSharedWithYouBy: "This is the folder shared with you by [person].",
    FolderType: "Folder type",
    FollowedSites: "Followed sites",
    From: "From",
    GenericNoResultsFoundText: "No results found",
    Group: "Group",
    HidePreview: "Hide preview",
    History: "History",
    Home: "Home",
    HubAssociatedHubs: "Associated hub sites",
    HubAssociatedSites: "Associated sites",
    HubSite: "Hub site",
    InactiveClient: "Inactive client",
    Importance: "Importance",
    IndividualFilesUpdated: "Individual files updated",
    InReplyTo: "In reply to",
    InsertAsAttachment: "Insert as Attachment",
    InsertAsLink: "Insert as Link",
    InsertFrom: "Insert from",
    InvalidEmail: "Invalid email",
    Item: "Item",
    Items: "Items",
    ItemsSelected: "items selected",
    ItemsToAddAsAttachmentsLinks: "Items to add as {placeholder}",
    ItemsToCopy: "Items to copy",
    ItemsToMove: "Items to move",
    ItemToCopy: "Item to copy",
    ItemToMove: "Item to move",
    LandingPage: "Landing page",
    LargestOnTop: "Largest on top",
    LeastRelevantOnTop: "Least relevant on top",
    LevelUp: "Level up",
    LibraryPermissions: "Library Permissions",
    LicenseRequired: "In order to have access to {placeholder} you need to have a paid license.",
    LicenseRequiredTitle: "License required",
    LimitReached: "Limit reached",
    Link: "Link",
    List: "List",
    ListItem: "List item",
    ListItemPickerSelectValue: "Select value",
    Lists: "Lists",
    LoadDefaults: "Load defaults",
    Loading: "Loading ...",
    LoadingClientGroupSites: "Loading client group sites",
    LoadingEmails: "Loading emails",
    LoadingFilters: "Loading filters",
    LoadingInputs: "Loading Inputs",
    LoadingOnly: "Loading",
    LoadingProfile: "Loading profile ...",
    LoadMore: "Load more results",
    Local: "local",
    LibrariesFailedToLoad: "Could not load: {placeholder}",
    LibrariesExceededThreshold: "Too large to sort or filter this way: {placeholder}. Ask an administrator to add an index to the column, or narrow the view with a search.",
    Location: "Location",
    Locations: "Microsoft 365 locations",
    LocationsView: "Locations",
    MailboxAccessDenied: 'Access denied - Your account ({account}) might not have permission to access the mailbox or this specific item.',
    MailboxAddress: "Mailbox address",
    MailboxAlreadyAdded: "Mailbox already added",
    MailboxAuthorizing: "Authorizing mailbox",
    Manage: "Manage",
    ManualClipboardCopyInstructions: "Automatic copy was blocked by the browser. Click Copy link to try again, or copy the generated link(s) below manually.",
    MaximumEmailMessagesSelected: "Maximum of {amount} email messages may be saved at once.",
    Me: "Me",
    Member: "Member",
    Members: "Members",
    MembersAdd: "Add members",
    MemberSelect: "Select member",
    MembersNotFound: "No members found",
    MembersNotSelected: "No members selected",
    Message: "Message",
    MessageComposeSaveSuccess: "Your message has been successfully saved. You may close this window and your message if they remain open.",
    MessageComposeSaveSendFailed: "Your message was saved, but it could not be sent automatically. Please send your message manually.",
    MessageComposeSaving: "Your message is being saved and will be sent once complete. Please wait...",
    MessageId: "Message-Id",
    MetadataNotUpdated: "Files were saved successfully. Make sure that the metadata has been updated accordingly",
    MetadataValidationFailed: "Validation failed for",
    MinorVersions: "Minor versions",
    MissingMetadata: "Missing metadata",
    Modified: "Modified",
    ModifiedBy: "Modified by",
    More: "More",
    MoreActions: "Show actions",
    MostRelevantOnTop: "Most relevant on top",
    MoveAll: "Move all",
    MoveItemDown: "Move pinned item down",
    MoveItems: "Move items",
    MoveItemUp: "Move pinned item up",
    MoveProgress: "Move progress",
    MoveProgressCounter: "{completed} of {total} items moved",
    MoveTo: "Move to",
    MovingItems: "Moving items...",
    MultipleFilesFoldersCopyMove: "Files/Folders with the same name can't be copied or moved to the same location.",
    MyApprovals: "My approvals",
    MyOrganization: "My organization",
    Name: "Name",
    New: "New",
    // Adjective used before a NEUTER document noun (document, workbook, notebook) in the
    // "New <template>" panel header. Gendered languages need a different form here than
    // before folder/link/presentation (see New).
    NewDocument: "New",
    NewestOnTop: "Newest on top",
    NewOnly: "New",
    No: "No",
    NoAppSpecificFiles: "No {context} files found.",
    NoEmailAvailable: "No email available",
    NoFilesSelected: "No files selected",
    NoFiltersAvailable: "No filters available",
    NoItemsFound: "No items found!",
    NoLocations: "No further locations",
    NoMoreFolders: "No folders are located in this directory!",
    NoMoreFoldersAndFiles: "This directory is empty.",
    NoResultsFound: "No results found",
    NoResultsForValue: "No results for this value",
    NoSubject: "No subject",
    NotAssignedToSite: "You are not assigned to any sites.",
    NotAssignedToTeam: "You are not a member of any teams.",
    NotWorkingOnOnlineVersion: "You are not working on the online version of this document.",
    Of: "of",
    Ok: "Ok",
    OldestOnTop: "Oldest on top",
    OneDrive: "OneDrive",
    OneOrMoreFilesLockedCheckedOut: "One or more files locked/checked out",
    Open: "Open",
    OpenFileInBrowser: "Open file in browser",
    OpenFileLocation: "Open file location",
    OpenFileLocationIn: "Open file location in",
    OpenFolder: "Open folder",
    OpenFolderInBrowser: "Open location in browser",
    OpenIn: "Open in",
    OpenOnlineDocumentWith: "Open the document in",
    OptionalComment: "Add a comment (optional)",
    Options: "Options",
    OriginalSubject: "Original subject",
    OutlookSettings: "Outlook settings",
    Overview: "Overview",
    Overwrite: "Overwrite/version existing files",
    OverwriteRequired: "Change the conflicting file name/s or choose the option to overwrite/version existing files.",
    Owner: "Owner",
    Participants: "Participants",
    PeopleYouChoose: "People you choose",
    Permissions: "Permissions",
    Pinned: "Pinned",
    PinnedItemsShownHere: "Pinned items will be shown here.",
    PinThisFile: "Pin this file",
    PinThisFolder: "Pin this location",
    PleaseSelectSomeoneShare: "Please select someone to share with",
    OnlyShareWithinOrganization: "You can only share within your organization.",
    OnlyShareWithExistingGuests: "You can only share with guests who already exist in your organization.",
    Preferences: "Preferences",
    PreparingCopy: "Preparing copy operation...",
    PreparingMove: "Preparing move operation...",
    PreviewNotAvailable: "Preview not supported or not available.",
    PriceLinkText: "You can view our prices here.",
    PrivacySensitiveCheckError: "Error checking for privacy sensitive data",
    PrivacySensitiveChecking: "Checking for privacy sensitive data",
    PrivacySensitiveDataFound: "Privacy sensitive data found",
    PrivacySensitiveDataNotChecked: "Privacy sensitive data not checked",
    PrivacySensitiveDataNotFound: "No privacy sensitive data found",
    PrivacySensitiveDisplay: "Privacy sensitive",
    PrivacySensitiveRedact: "Redact privacy sensitive data",
    Private: "Private",
    Progress: "Progress",
    Properties: "Properties",
    Publish: "Publish",
    PublishedMajorVersion: "Current published major version",
    QuickAccess: "Quick access",
    ReadMore: "Read More...",
    ReadOnly: "Read-only",
    Reason: "Reason",
    Reassign: "Reassign",
    ReassignTo: "Reassign to",
    Received: "Received",
    Recent: "Recent",
    RecentItemsShownHere: "Recent items will be shown here.",
    RecentlyEditYou: "You recently edited this",
    RecentlyOpened: "Recently opened",
    RecentlyOpenedYou: "You recently opened this",
    Recheck: "Recheck",
    Recipients: "Recipients",
    RecipientsRequired: "Recipients required",
    RecipientsRequiredMessage: "At least one recipient is required.",
    Recommended: "Recommended",
    Redact: "Redact",
    References: "References",
    Refresh: "Refresh",
    Reject: "Reject",
    Relevance: "Relevance",
    Remove: "Remove",
    RemoveFromRecent: "Remove from recent",
    RemoveFromSuggestions: "Remove from suggestions",
    Rename: "Auto Rename",
    RenameOnly: "Rename",
    RenameTextFileOption: "You have file names that already exist in this folder. Please specify an option.",
    Replace: "Replace/version",
    ReplaceFile: "Replace file",
    ReplacementFileRequired: "Replacement file required.",
    ReplacementFileRequiredMessage: "Please select a replacement file from the list of available files or by browsing for a file.",
    ReplaceOnly: "Replace",
    ReplyTo: "Reply to",
    RequestAccess: "Request access",
    Requester: "Requester",
    RequestTrial: "Request a free trial",
    RequestTrialText: "With our trial version you can try Docubird for free. For Docubird to function properly, it is important to know how you have implemented SharePoint and Teams.",
    Required: "Required",
    Reset: "Reset",
    ResetToDefault: "Reset to default",
    Restoring: "Restoring",
    RetrievingFolders: "Retrieving folders",
    RetrievingFoldersAndFiles: "Retrieving files and folders",
    RetrievingInfo: "Retrieving information",
    RetryAfter: "Please try again after a few minutes",
    Save: "Save",
    SaveAll: "Save all",
    SaveAndSend: "Save and send",
    SaveAsPdf: "Save as pdf",
    SaveAsPDFQuestion: "Save as PDF?",
    SaveFormat: "Save format",
    SaveFormatDefault: "Default save format",
    SaveFormatEmailAsPdf: "Emails as PDF",
    SaveFormatEverythingAsPdf: "Everything as PDF",
    SaveFormatInfo: "Only supported file types (such as Office documents and emails) can be converted to PDF. Other files keep their original format. The document list shows the resulting type for each file.",
    SaveFormatOriginal: "Keep original formats",
    SaveEmails: "Save email(s)",
    SaveEmailsConfirmBody: "After clicking the \"OK\" button, you will be redirected to the home screen to choose a location where you want to save the emails.",
    SaveEntireFolder: "Save entire folder",
    SaveInProgress: "Saving...",
    SaveMail: "Save this mail?",
    SaveOnSend: "Save on send",
    SaveProperties: "Save properties",
    SaveSelected: "Save selected email(s)",
    SaveSelectedFiles: "Save selected files",
    SaveSelection: "Save selection",
    SaveTo: "Save to ",
    SaveToAnotherLocation: "Save to another location",
    SavingDisabled: "Saving disabled",
    SavingFile: "Saving file",
    SavingFiles: "Saving files",
    SavingFilesNotAllowed: "Saving files to this location is not allowed",
    Search: "Search",
    SearchAllDocuments: "Search all documents",
    SearchDescription: "Search for a specific site",
    SearchFields: "Search fields",
    SearchingContent: "Searching content...",
    SearchingFor: "Search for...",
    SearchResults: "Search Results",
    SearchResultsRetrieval: "Retrieving search results...",
    SearchSectionFilter: "Search {section} filters",
    Select: "Select",
    SelectAction: "Select action",
    SelectAFile: "Select a file",
    SelectAll: "Select all",
    SelectDestinationDirectory: "Please select a destination directory.",
    SelectDestinationDirectoryConfirmCopy: "Are you sure you want to copy {amount} items from {source} to the current directory?",
    SelectDestinationDirectoryConfirmMove: "Are you sure you want to move {amount} items from {source} to the current directory?",
    Selected: "Selected",
    SelectedFile: "Selected file",
    SelectItemsToSave: "Select items to save",
    SelectOption: "Select an option",
    SelectSaveLocation: "Select a location to save",
    SelectSensitivityLabel: "Select a sensitivity label",
    SelectSpecificDates: "Select specific dates",
    SelectTerm: "Select term",
    Send: "Send",
    SendOnSaveFailed: "Your file was saved, but the email could not be sent automatically. Please send it manually.",
    Sending: "Sending",
    Sensitivity: "Sensitivity",
    Share: "Share",
    ShareWithGroup: "Share with group",
    ShareWithGroupDescription: "Create a link to the selected file(s) in the same library on the selected group sites.",
    ShareWithGroupSelectAll: "Select all",
    ShareWithGroupSharing: "Sharing {0} of {1} sites",
    ShareWithGroupResultShared: "Shared with {0} of {1} sites",
    ShareWithGroupResultSharedUpdated: "Shared with {0} of {1} sites, {2} updated",
    ShareWithGroupResultNone: "Nothing was shared",
    ShareWithGroupPartial: "Shared with partial metadata",
    ShareWithGroupNoLibrary: "No matching library",
    ShareWithGroupNoLibraryNamed: "No matching library ({0})",
    ShareWithGroupFailed: "Failed",
    ShareWithGroupNoPermission: "No permission on this site",
    ShareWithGroupSeedUnavailable: "The source file or library could not be read",
    ShareWithGroupSeedsUnresolved: "{0} of {1} files could not be resolved; nothing was shared",
    ShareWithGroupSites: "Group sites",
    ShareWithGroupOutsideLibrary: "File is not inside its library",
    ShareWithGroupLinkWithoutSharing: "Link without sharing",
    ShareWithGroupFilesDone: "{0} of {1} files",
    ShareWithGroupNotVisible: "Link not visible to others (it could not be checked in or published)",
    ShareWithGroupNameInUse: "A different link already uses this name",
    ShareWithGroupAwaitingApproval: "Awaiting approval",
    ShareWithGroupRenamed: "Saved as {0}",
    Shared: "Shared",
    SharedBy: "Shared by",
    SharedItemsShownHere: "Files shared with you will be shown here.",
    SharedLinkSuccessfullyCopied: "link(s) successfully copied.",
    SharedMailboxMultiSelectSaveUnavailable: "These emails are in a shared mailbox that couldn't be identified, so they can't be saved together. Open one email from the shared mailbox first, then select the emails again.",
    SharedMailboxes: "Shared mailboxes",
    SharedThisItem: "Shared this item",
    SharedWith: "Shared with",
    ShareLinkWith: "Share the link with",
    ShareLinkAccessDenied: "You don't have permission to create a sharing link for this item, or sharing is turned off for this site.",
    ShareLinkSlowNotice: "Creating the sharing link. SharePoint is responding slowly, this can take a few minutes. Closing this panel cancels it.",
    ShareLinkTimedOut: "SharePoint didn't create the sharing link in time. Try again, or share the file from SharePoint.",
    ShareLinkReadyToCopy: "The link is ready. Click Copy link to copy it, or copy it below.",
    ShareMailMayNotBeSent: "The email may not have been sent. Check your Sent Items before trying again.",
    ShareMailSlowNotice: "Sending the email is taking longer than usual.",
    SharepointDocumentLibrary: "Document Library",
    SharePointDocumentSet: "Document set",
    SharepointFolder: "Folder",
    SharePointHubSite: "Hub Site",
    SharepointSite: "Site",
    SharepointSubsite: "Subsite",
    ShareToTeams: "Share to Teams",
    ShareWith: "Share with",
    ShareWithPeople: "People to share with",
    ShowAllColumns: "Show all columns",
    ShowDateRangeSlider: "Show date range slider",
    ShowLess: "Show less",
    ShowMore: "Show more",
    ShowPinned: "Show pinned",
    ShowPreview: "Show preview",
    ShowRecent: "Show recent",
    ShowShared: "Show shared",
    SigningIn: "Signing in ...",
    SigningRequest: "Signing request",
    SigningRequestCreated: "Signing request created",
    SigningRequestError: "Signing request failed",
    SignInWithDifferentAccount: "Sign in with a different account",
    SitePermissions: "Site Permissions",
    Sites: "Sites",
    SitesFollowedShownHere: "Sites you follow will be shown here.",
    Size: "Size",
    SmallestOnTop: "Smallest on top",
    SortBy: "Sort by",
    SortOrder: "Sort order",
    Status: "Status",
    Strict: "Strict",
    StrictSearchInfo: "Only show results where the name contains the search term.",
    Subject: "Subject",
    SubmitForApproval: "Submit for approval",
    SubscriptionExpired: "Your Docubird license has expired. Please contact your application administrator to renew your license through Microsoft.",
    SubscriptionInvalid: "There are no free Docubird licenses available within this tenant. Contact your application administrator to free up licenses via {admin-url-placeholder} or to purchase additional licenses through Microsoft.",
    SubscriptionUpgradeRequired: "Your current license does not include access to Docubird DMS. Please contact your application administrator to request a license upgrade.",
    Subsites: "Subsites",
    Success: "Success",
    SuggestedContacts: "Suggested contacts",
    SuggestedItemsShownHere: "Suggested locations will be shown here.",
    SuggestedPeople: "Suggested people",
    SuggestedValues: "Suggested values",
    Suggestions: "Suggestions",
    TaxonomyPickerExpandTitle: "Expand this Term Set",
    TaxonomyPickerInLabel: "in",
    TaxonomyPickerInvalidTerms: "Invalid term(s): {0}",
    TaxonomyPickerMenuTermSet: "Menu for Term Set",
    TaxonomyPickerNoTerms: "Term set does not contain any terms",
    TaxonomyPickerTermSetLabel: "Term Set",
    TaxonomyPickerTermsNotFound: "The next selected term(s) could not be found in the term store: {0}",
    TeamsChannel: "Teams Channel",
    TeamsChannelNotLoaded: "This channel's files location has not yet been provisioned.",
    TeamsFolder: "Teams Folder",
    TeamsSite: "Teams Site",
    Templates: "Templates",
    TessActiveProjects: "Active projects",
    TessCompletedProjects: "Completed projects",
    TessConceptProjects: "Concept projects",
    TessFolders: "Dossiers",
    TessShowAllAccounts: "Show all accounts",
    TessShowContactAccounts: "Show contact accounts",
    ThemeDark: "Dark",
    ThemeFollowingSystem: "Following Office theme — currently {0}",
    ThemeLight: "Light",
    ThemeSystem: "System",
    Title: "Title",
    TitleAutoSet: "[Autoset to email subject / filename]",
    To: "To",
    ToDestination: "to",
    TopLevelItems: "Top Level Items",
    Trending: "Trending",
    TrialExpiredText: "Your free 30-day trial has expired. Would you like to continue using Docubird?",
    Type: "Type",
    UnableToAppendLinkTryAgain: "Unable to attach a shareable link! Please try again!",
    UnableToAttach: "Unable to attach email attachments!",
    UnableToAttachTryAgain: "Unable to attach email attachments! Please try again!",
    UnableToRetrieveFile: "Unable to retrieve the current file! Please try again!",
    UnableToRetrieveTeams: "We were unable to retrieve your team sites",
    Unassigned: "Unassigned",
    Unknown: "Unknown",
    UnpinFile: "Unpin this file",
    UnpinFolder: "Unpin this location",
    Unpublish: "Unpublish",
    UpdateIndividualFile: "Update individual file",
    UpdateIndividualFileMetaData: "Update individual file properties",
    Upload: "Upload",
    UploadToHix: "Upload to HIX",
    ScanCustomFields: "Scan for custom fields",
    ScanCustomFieldsFailed: "Custom fields scan failed",
    ScanCustomFieldsNoFiles: "Select template files to scan, or clear the selection to scan the whole library",
    ScanCustomFieldsScanning: "Scanning templates…",
    SuggestPlaceholders: "Suggest placeholders (AI)",
    SuggestPlaceholdersTitle: "AI placeholder suggestions",
    SuggestPlaceholdersInstruction: "Optional instruction (e.g. 'make the address block use client fields')",
    SuggestPlaceholdersRun: "Suggest",
    SuggestPlaceholdersApply: "Apply selected",
    SuggestPlaceholdersEmpty: "No suggestions found for this template.",
    SuggestPlaceholdersRejected: "Not applicable",
    SuggestPlaceholdersReplaceAll: "Replace all",
    SuggestPlaceholdersHeaderBadge: "in header/footer",
    SuggestPlaceholdersApproxLayout: "Layout approximate — open in Word for exact placement",
    SuggestPlaceholdersAppliedCount: "{0} of {1} placeholders applied",
    SuggestPlaceholdersSkippedOne: "Skipped",
    SuggestPlaceholdersNoneApplied: "No placeholders could be applied — the template was not changed.",
    SuggestPlaceholdersUndo: "Undo",
    SuggestPlaceholdersReverted: "Reverted — the template is back to how it was before the changes were applied. Both steps remain in its version history.",
    // The one message that keeps the version label: it is the only thing that tells the user
    // WHICH entry to pick in SharePoint's version list when they have to do this by hand.
    SuggestPlaceholdersUndoFailed: "The template could not be reverted — restore version {0} from version history.",
    SuggestPlaceholdersRevertedStale: "Reverted, but the template could not be re-checked afterwards. Run Suggest again before applying.",
    SuggestPlaceholdersRevertScanFailed: "the custom fields could not be re-scanned after the revert — scan this template again to refresh them",
    SuggestPlaceholdersSelectOne: "Select a single template file.",
    SuggestPlaceholdersTruncated: "The template is long; suggestions cover the first part only.",
    SuggestPlaceholdersPreviousSlide: "Previous slide",
    SuggestPlaceholdersNextSlide: "Next slide",
    SuggestPlaceholdersPinnedOccurrence: "Occurrence {0} of {1}",
    ScanCustomFieldsScanned: "templates scanned",
    ScanCustomFieldsWithFields: "with custom fields",
    ScanCustomFieldsSkipped: "skipped",
    ScanCustomFieldsSkippedHeader: "Templates skipped (not scanned)",
    UnfilledColumnPlaceholdersWarning: "Placeholders without a matching column in this library",
    UnfilledCrmPlaceholdersWarning: "Client (CRM) placeholders that could not be filled",
    CustomFieldsSection: "Custom fields",
    CustomFieldsMissingWarning: "Some custom fields were not filled — rescan the template library",
    CustomFieldsUnusedWarning: "Some values did not match the template's custom fields — if the template was edited, rescan the template library",
    HixClient: "HIX client",
    HixSearchClient: "Search for a client",
    HixUploadType: "Upload type",
    HixUploadTypeGeneric: "Upload file(s)",
    HixFilesToUpload: "Files to upload",
    HixMaxFilesWarning: "You can upload a maximum of 6 files to a HIX task. Reduce your selection.",
    HixNoSupportedFiles: "None of the selected files have a type HIX accepts.",
    HixUnsupportedFilesWarning: "These files have a type HIX does not accept and will be skipped:",
    HixUploadSuccess: "Files uploaded to HIX.",
    HixUploadFailed: "Failed to upload files to HIX.",
    HixSomeFilesFailed: "Some files could not be uploaded:",
    HixOpenTask: "Open the task in HIX",
    UploadCompletedSuccessfully: "Upload completed successfully",
    Uploaded: "Uploaded",
    UploadFiles: "Upload Files",
    Uploading: "Uploading",
    UserChangingRole: "Changing user role",
    UserRemove: "Removing user",
    UsersAddError: "There was an error adding one or more users",
    ValuesNotFound: "values not found",
    VerifyingFiles: "Verifying files",
    Version: "Version",
    VersionConfirmDeleteAllMessage: "Are you sure you want to delete all versions?",
    VersionConfirmDeleteAllMinorMessage: "Are you sure you want to delete all minor versions?",
    VersionDelete: "Delete",
    VersionHistory: "Version history",
    VersionMajorPublished: "Major version (published)",
    VersionMinorDraft: "Minor version (draft)",
    VersionMinorOverwrite: "Overwrite the current minor version",
    VersionRestore: "Restore",
    VersionsDeleteAll: "Delete all versions",
    VersionsDeleteMinors: "Delete minor versions",
    VersionStatusApproved: "Approved - This item will become visible to all users",
    VersionStatusPending: "Pending - This item will remain visible to its creator and all users who can see draft items",
    VersionStatusRejected: "Rejected - This item will be returned to its creator only",
    VersionView: "View",
    ViewPendingApprovalsWindow: "View all pending approvals in separate window.",
    Views: "Views",
    Welcome: "Welcome",
    WelcomeForAdmins: "For admins",
    WelcomeForUsers: "For users",
    WelcomeGoToDocubird: "Go to Docubird",
    WelcomeLoginText: "Sign in to Microsoft 365",
    WelcomeOpened: "Opened",
    WelcomeOpensInNewWindow: "{placeholder} (opens in a new window)",
    WelcomeOptionDirect: "Go straight to Docubird",
    WelcomeOptionSetup: "Set up Docubird",
    WelcomeOptionTour: "Take the tour",
    WelcomeSubtitle: "Where would you like to start?",
    WelcomeText: "Docubird is a Microsoft 365 add-in for streamlining document management in SharePoint, OneDrive, and Teams.",
    WelcomeTitle: "Welcome to {placeholder}",
    WrongUserPermissionsSave: "You don't have the required permissions to save files to this location.",
    WrongUserPermissionsUpdate: "You don't have the required permissions to update files in this location.",
    Yes: "Yes",
    You: "You"
  },
  nl: {
    AccessDenied: "Toegang geweigerd",
    AccessRevoked: "Uw toegang tot {placeholder} is ingetrokken",
    Account: "Account",
    AccountDeactivated: "Account voor {placeholder} is gedeactiveerd. Neem contact op met uw beheerder voor assistentie.",
    ActionFailed: "Actie mislukt. Probeer het later nog eens.",
    ActionSucceed: "Actie geslaagd!",
    Add: "Toevoegen",
    AddAttachment: "Als bijlagen",
    AddEmail: "Toevoegen aan e-mail",
    AddFiles: "Bestanden toevoegen",
    AddFilesAdditional: "Extra bestanden toevoegen",
    AddShareableLink: "Als links",
    AdvancedSearch: "Geavanceerd zoeken",
    All: "Alle",
    AllAlt: "Alles",
    AllDocuments: "Alle documenten",
    AllDocumentsCapReached: "Er worden {placeholder} documenten weergegeven — de limiet voor deze weergave. Latere rijen kunnen onvolledig zijn: sommige bibliotheken zijn niet volledig doorgelezen. Open een bibliotheek of gebruik zoeken of een filter om alles te zien.",
    AllowApprovals: "Mijn goedkeuringen inschakelen",
    AllowApprovalsMessage: "Schakel Docubird in om toegang te krijgen tot uw goedkeuringsinformatie.",
    AlreadyAssigned: "Reeds toegewezen aan deze goedkeurder",
    AlreadyExists: "Bestaat al",
    AndSend: "en versturen",
    Anyone: "Iedereen",
    App: "app",
    Appearance: "Weergave",
    Apply: "Toepassen",
    Approval: "Goedkeuring",
    ApprovalCenter: "Taken",
    ApprovalRequestNotAllowedOwner: "Het goedkeuringsverzoek mag niet opnieuw worden toegewezen aan de goedkeuringseigenaar.",
    ApprovalsLoading: "Goedkeuringen laden...",
    ApprovalsShownHere: "Goedkeuringen worden hier getoond.",
    Approve: "Goedkeuren",
    Approvers: "Goedkeurders",
    Ascending: "Oplopend",
    AsPdf: "als pdf",
    Attachments: "Bijlagen",
    AttachmentsSelected: "geselecteerde bijlagen",
    AttentionSaveModeActive: "Let op: u bevindt zich nog steeds in de email opslaan modus!",
    AutoFolderCreationNoContent: "Gebruik het zoekveld hierboven om naar bestanden en mappen te zoeken.",
    Automation: "Automatisering",
    AutomationFlowDescription: "Automatiseringsprocesbeschrijving",
    AutomationFlowName: "Automatiseringsprocesnaam",
    AutomationFlowNotSelected: "Geen automatiseringsproces geselecteerd",
    AutomationFlowRequest: "Automatiseringsproces aanvraag",
    AutomationFlowRequestError: "Automatiseringsverzoek is mislukt",
    AutomationFlowRequestSuccess: "Automatiseringsverzoek succesvol verzonden",
    AutoOpenDocubird: "Docubird automatisch openen voor dit document?",
    AutoRemoveMailItemAttachments: "Verwijder bijlagen van e-mailitem bij opslaan",
    AutoSelectAttachments: "Bijlagen automatisch selecteren",
    AutoSetEmailProperty: "[Autoset naar e-mail eigenschap '{emailProperty}']",
    AvailableFiles: "Beschikbare bestanden",
    Back: "Terug",
    BackToWork: "Ga weer aan het werk",
    Bcc: "Bcc",
    BlockDownload: "Blok downloaden",
    Browser: "browser",
    By: "door",
    Cancel: "Annuleer",
    CancelApproval: "Goedkeuring annuleren",
    CancelAssignment: "Opdracht annuleren",
    CancelAssignmentConfrimMessage: "Weet je zeker dat je de opdracht wilt annuleren?",
    Cancelled: "Geannuleerd",
    CanEditMakesChanges: "Kan bewerken - Wijzigingen aanbrengen",
    CanViewCannotMakeChanges: "Kan bekijken - Kan geen wijzigingen aanbrengen",
    Categories: "Categorieën",
    Cc: "Cc",
    Channels: "Kanalen",
    CheckedOutBy: "Uitgecheckt door",
    CheckedOutByYou: "Je hebt dit item uitgecheckt",
    CheckIn: "Check in",
    CheckOut: "Uitchecken",
    ChooseVersion: "Versie kiezen",
    Clear: "Wis",
    ClearFilter: "Filter wissen",
    ClearSearch: "Zoekactie verwijderen",
    ClientGroup: "Klantgroep",
    ClientGroupSitesCapped: "Documenten van {0} van {1} klantgroepsites worden weergegeven",
    ClientGroupSearchPartial: "Sommige sites van de klantgroep konden niet worden doorzocht.",
    Columns: "Kolommen",
    ClipboardBlockedInstructions: "Toegang tot het klembord is geblokkeerd. Sta klembordtoegang toe in de browserinstellingen en probeer het opnieuw, of kopieer de gegenereerde link(s) hieronder handmatig.",
    Close: "Sluiten",
    Comment: "Commentaar",
    Complete: "Voltooid",
    Confirm: "Bevestig",
    ConfirmDeleteDocuments: "Weet u zeker dat u {placeholder} document(en) wilt verwijderen? Ze worden naar de prullenbak verplaatst.",
    ConfirmDeleteMailbox: "Weet u zeker dat u {mailbox} wilt verwijderen?",
    ConfirmPublish: "Wil je publiceren?",
    ContactAdministrator: "Neem contact op met uw beheerder voor assistentie.",
    ContactUs: "Neem gerust contact met ons op voor een passende offerte.",
    ContentType: "Inhoudstype",
    ContentTypes: "Inhoudstypen",
    Continue: "Doorgaan",
    ConversationIndex: "Conversatie-index",
    ConversationTopic: "Conversatie-onderwerp",
    ConvertEmailToPdf: 'E-mail converteren naar pdf bij opslaan',
    ConvertToPdf: 'Converteren naar PDF',
    Copied: "Gekopieerd",
    CopyAll: "Alles kopiëren",
    CopyingItems: "Items kopiëren...",
    CopyItems: "Kopie items",
    CopyLink: "Link kopiëren",
    CopyProgress: "Kopieer vooruitgang",
    CopyProgressCounter: "{completed} van {total} items gekopieerd",
    CopyTo: "Kopie naar",
    Create: "Aanmaken",
    Created: "Aangemaakt",
    CreateEmail: "Maak een nieuwe e-mail",
    CreateEmailWithAttachment: "Maak een e-mail met bijlage",
    CreateEmailWithLink: "Maak een e-mail met een link",
    CreateWithAttachments: "Met bijlagen",
    CreateWithShareableLinks: "Met links",
    Datasource: "databron",
    Date: "Datum",
    Default: "Standaard",
    Delete: "Verwijderen",
    DeleteSPItemConfirmMessage: "Weet je zeker dat je dit item(s) naar de prullenbak van de site wilt sturen?",
    Deleting: "Verwijderen",
    Descending: "Aflopend",
    Description: "Omschrijving",
    DeselectAll: "Deselecteer alles",
    Details: "Details",
    DiscardCheckOut: "Uitchecken weggooien",
    Disconnect: "Afmelden",
    DocumentLibraries: "Documentbibliotheken",
    DocumentLibrary: "Documentbibliotheek",
    DocumentSettings: "Document-instellingen",
    DocumentSharedWithYouBy: "Dit is het document dat [person] met u heeft gedeeld.",
    DocumentSharedWithYouByEmailSubject: "[person] heeft \"[file_name]\" met je gedeeld.",
    DocumentShareSuccess: "\"[file_name]\" succesvol gedeeld.",
    Done: "Klaar",
    Download: "Download",
    DownloadAsPdf: "Download als pdf",
    DownloadAsPdfFailure: "Kan het bestand niet omzetten naar pdf-formaat. Het bestand kan een verkeerd formaat hebben, te groot, of mogelijk corrupt zijn.",
    DownloadFailure: "Download mislukt",
    Downloading: "Downloaden",
    DownloadingAttachments: "Bijlagen downloaden",
    DoYouWantToCreateFolder: "Wilt u de e-mails opslaan in een nieuwe map?",
    Draft: "Concept",
    DueDate: "Vervaldatum",
    DueDateDescription: "Standaard {days} dagen.",
    DuplicateResolved: "Uw dubbele bestandsnamen zijn opgelost. U kunt doorgaan met opslaan!",
    EditXItems: "Bewerk {itemCount} items",
    EmailHeaderMapping: "Toewijzing van e-mailheaders",
    Emails: "E-mails",
    Empty: "Leeg",
    EmptyColumnHint: "(leeg)",
    EnableEmails: "E-mails inschakelen",
    EnterDate: "Vul een datum in",
    EnterEmail: "Voer namen, e-mails of gebruikersgroepen in",
    EnterFolderName: "Voer een mapnaam in",
    EnterLinkWebPageFile: "Voer de link naar de webpagina of het bestand in",
    EntireFolderSelected: "Gehele map geselecteerd",
    Error: "Fout",
    ErrorConnectingToServer: "Fout bij het verbinden met de server",
    ErrorDeletingFiles: "Er is een fout opgetreden bij het verwijderen van een of meer bestanden",
    ErrorMessageGeneric: "Er is iets fout gegaan",
    ErrorWhileUpdatingMetadata: "Er is een fout opgetreden bij het updaten van uw metadata",
    ExchangeSettings: "Exchange-instellingen",
    ExternalContent: "Externe inhoud",
    FetchProgressCounter: "{total} items opgehaald",
    FetchProgressCounterAll: "Alle items ophalen...",
    FieldRequired: "Veld is verplicht",
    FileBackgroundSave: "Uw bestanden worden op de achtergrond opgeslagen...",
    FileBackgroundSaveFailure: "Er is iets fout gegaan",
    FileCheckoutAndOpen: "Uitchecken en openen",
    FileCheckoutAndOpenInBrowser: "Uitchecken en openen in de browser",
    FileCheckoutRequired: "Dit bestand moet uitgecheckt worden voordat wijzigingen kunnen worden aangebracht.",
    FileCount: "Aantal bestanden",
    FileCurrentlyCheckedOut: "Dit bestand is momenteel uitgecheckt",
    FileDeleted: "Bestand niet beschikbaar",
    FileInfo: "Bestandsinformatie",
    FileLocationError: "Kan bestandslocatie niet openen.",
    FileLocationUnknown: "Bestandslocatie onbekend",
    FileName: "Bestandsnaam",
    FileNotExist: "Bestand bestaat niet meer!",
    FileNotFound: "Bestand niet gevonden",
    FileNotSaved: "Zorg ervoor dat uw bestand lokaal is opgeslagen",
    FileOpenReadOnly: "Openen als alleen-lezen",
    FileOpenReadOnlyInBrowser: "Openen als alleen-lezen in de browser",
    FilePlural: "bestand(en)",
    FileRecentlyDeleted: "Het bestand is verwijderd of verplaatst, of u heeft er geen toegang meer toe",
    Files: "Bestanden",
    FileSameCheckedOut: "Een bestand met deze naam is al uitgecheckt",
    FileSameLocked: "Een bestand met deze naam is vergrendeld",
    FileSameName: "Er bestaat al een bestand met deze naam",
    FileSaveSuccess: "Uw bestanden zijn succesvol opgeslagen",
    FileSaveSuccessSingle: "Bestand succesvol opgeslagen",
    FileSelected: "Bestand geselecteerd",
    FilesNotSuccessfullyUploaded: "De volgende bestanden zijn niet succesvol geüpload",
    FilesSelected: "Bestanden geselecteerd",
    FilesSelectedToUpload: "geselecteerde bestand(en) om te uploaden",
    FileVersionLimitReached: "Limiet voor bestandsversie bereikt",
    Filter: "Filter",
    FilterExcludesLibraries: "Verborgen door het filter (kolom niet aanwezig): {placeholder}",
    FilterDateStepIn30Days: "Over 30 dagen",
    FilterDateStepIn3Months: "Over 3 maanden",
    FilterDateStepIn3MonthsOrMore: "Over 3 maanden of langer",
    FilterDateStepIn7Days: "Over 7 dagen",
    FilterDateStepInAYearOrMore: "Over een jaar of langer",
    FilterDateStepLast30Days: "In de afgelopen 30 dagen",
    FilterDateStepLast3Months: "In de afgelopen 3 maanden",
    FilterDateStepLast7Days: "In de afgelopen 7 dagen",
    FilterDateStepSince: "Sinds",
    FilterDateStepSinceYesterday: "Sinds gisteren",
    FilterDateStepToday: "Vandaag",
    FilterDateStepTomorrow: "Morgen",
    FilterResults: "Filter resultaten",
    Finalizing: "Afronden",
    Finished: "Helemaal klaar",
    Folder: "Map",
    FolderCreate: "Nieuwe map",
    FolderCreateSuccess: "De map is succesvol aangemaakt",
    FolderDeleted: "Map niet beschikbaar",
    FolderName: "Mapnaam",
    FolderNotExist: "Map bestaat niet meer!",
    FolderRecentlyDeleted: "De map is verwijderd of verplaatst, of u heeft er geen toegang meer toe",
    Folders: "Mappen",
    FolderSameName: "Er bestaat al een map met deze naam",
    FolderSameNameAutoRename: "Er bestaat al een map of mappen met dezelfde naam. De geüploade map(pen) krijgt (krijgen) bij het uploaden automatisch een andere naam.",
    FolderSharedWithYouBy: "Dit is de map die met u is gedeeld door [person].",
    FolderType: "Maptype",
    FollowedSites: "Gevolgde sites",
    From: "Van",
    GenericNoResultsFoundText: "Geen resultaten gevonden",
    Group: "Groep",
    HidePreview: "Verberg voorbeeld",
    History: "Geschiedenis",
    Home: "Thuis",
    HubAssociatedHubs: "Bijbehorende hubsites",
    HubAssociatedSites: "Bijbehorende sites",
    HubSite: "Hubsite",
    InactiveClient: "Inactieve klant",
    Importance: "Belangrijkheid",
    IndividualFilesUpdated: "Individuele bestanden bijgewerkt",
    InReplyTo: "Als antwoord op",
    InsertAsAttachment: "Invoegen als bijlage",
    InsertAsLink: "Invoegen als link",
    InsertFrom: "Invoegen vanaf",
    InvalidEmail: "Ongeldige e-mail",
    Item: "Item",
    Items: "Items",
    ItemsSelected: "items geselecteerd",
    ItemsToAddAsAttachmentsLinks: "Items om toe te voegen als {placeholder}",
    ItemsToCopy: "Items om te kopiëren",
    ItemsToMove: "Items om te verplaatsen",
    ItemToCopy: "Item om te kopiëren",
    ItemToMove: "Item om te verplaatsen",
    LandingPage: "Landingspagina",
    LargestOnTop: "Grootste bovenaan",
    LeastRelevantOnTop: "Minst relevante bovenaan",
    LevelUp: "Niveau omhoog",
    LibraryPermissions: "Bibliotheekmachtigingen",
    LicenseRequired: "Om toegang te krijgen tot {placeholder} moet u een betaalde licentie hebben.",
    LicenseRequiredTitle: "Licentie vereist",
    LimitReached: "Limiet bereikt",
    Link: "Link",
    List: "Lijst",
    ListItem: "Lijstitem",
    ListItemPickerSelectValue: "Selecteer waarde",
    Lists: "Lijsten",
    LoadDefaults: "Laad standaardinstellingen",
    Loading: "Laden ...",
    LoadingClientGroupSites: "Klantgroepsites laden",
    LoadingEmails: "E-mails laden",
    LoadingFilters: "Filters laden",
    LoadingInputs: "Laad meer resultaten",
    LoadingOnly: "Laden",
    LoadingProfile: "Profiel laden ...",
    LoadMore: "Laad meer resultaten",
    Local: "lokaal",
    LibrariesFailedToLoad: "Kan niet laden: {placeholder}",
    LibrariesExceededThreshold: "Te groot om zo te sorteren of filteren: {placeholder}. Vraag een beheerder om een index op de kolom toe te voegen, of beperk de weergave met een zoekopdracht.",
    Location: "Locatie",
    Locations: "Microsoft 365 locaties",
    LocationsView: "Locaties",
    MailboxAccessDenied: 'Uw account ({account}) heeft mogelijk geen toestemming om toegang te krijgen tot de mailbox of dit specifieke item.',
    MailboxAddress: "Mailbox adres",
    MailboxAlreadyAdded: "Mailbox reeds toegevoegd",
    MailboxAuthorizing: "Mailbox machtigen",
    Manage: "Beheren",
    ManualClipboardCopyInstructions: "Automatisch kopiëren is geblokkeerd door de browser. Klik op Link kopiëren om het opnieuw te proberen of kopieer de gegenereerde link(s) hieronder handmatig.",
    MaximumEmailMessagesSelected: "Er kunnen maximaal {amount} e-mailberichten tegelijk worden opgeslagen.",
    Me: "Ik",
    Member: "Lid",
    Members: "Leden",
    MembersAdd: "Leden toevoegen",
    MemberSelect: "Selecteer lid",
    MembersNotFound: "Geen lede gevind nie",
    MembersNotSelected: "Geen leden geselecteerd",
    Message: "Bericht",
    MessageComposeSaveSuccess: "Uw bericht is succesvol opgeslagen. U kunt dit venster en uw bericht sluiten als deze nog open staan.",
    MessageComposeSaveSendFailed: "Uw bericht is opgeslagen, maar kon niet automatisch worden verzonden. Verstuur uw bericht handmatig.",
    MessageComposeSaving: "Uw bericht wordt opgeslagen en zal worden verzonden zodra het voltooid is. Even geduld alstublieft...",
    MessageId: "E-mailbericht-Id",
    MetadataNotUpdated: "Bestanden zijn succesvol opgeslagen. Zorg ervoor dat de metagegevens dienovereenkomstig zijn bijgewerkt",
    MetadataValidationFailed: "Validatie mislukt voor",
    MinorVersions: "Secundaire(concept) versies",
    MissingMetadata: "Ontbrekende metadata",
    Modified: "Aangepast",
    ModifiedBy: "Aangepast door",
    More: "Meer",
    MoreActions: "Toon acties",
    MostRelevantOnTop: "Most relevant on top",
    MoveAll: "Alles verplaatsen",
    MoveItemDown: "Verplaats het vastgezette item naar beneden",
    MoveItems: "Verplaatsen items",
    MoveItemUp: "Verplaats het vastgezette item naar boven",
    MoveProgress: "Verplaatsen vooruitgang",
    MoveProgressCounter: "{completed} van {total} items verplaatst",
    MoveTo: "Verplaatsen naar",
    MovingItems: "Items verplaatsen...",
    MultipleFilesFoldersCopyMove: "Bestanden/Mappen met dezelfde naam kunnen niet naar dezelfde locatie worden gekopieerd of verplaatst.",
    MyApprovals: "Mijn goedkeuringen",
    MyOrganization: "Mijn organisatie",
    Name: "Naam",
    New: "Nieuwe",
    // "Nieuw Word document" (het document) — but "Nieuwe map" / "Nieuwe presentatie" keep New.
    NewDocument: "Nieuw",
    NewestOnTop: "Nieuwste bovenaan",
    NewOnly: "Nieuw",
    No: "Nee",
    NoAppSpecificFiles: "No {context}-bestanden gevonden.",
    NoEmailAvailable: "Geen e-mail beschikbaar",
    NoFilesSelected: "Geen bestanden geselecteerd",
    NoFiltersAvailable: "Geen filters beschikbaar",
    NoItemsFound: "Geen items gevonden!",
    NoLocations: "Geen verdere locaties",
    NoMoreFolders: "Er bevinden zich geen mappen in deze map!",
    NoMoreFoldersAndFiles: "Deze map is leeg.",
    NoResultsFound: "Geen resultaten gevonden",
    NoResultsForValue: "Geen resultaten voor deze waarde",
    NoSubject: "Geen onderwerp",
    NotAssignedToSite: "U bent geen lid van een site.",
    NotAssignedToTeam: "U bent geen lid van een team.",
    NotWorkingOnOnlineVersion: "U werkt niet aan de online versie van dit document.",
    Of: "van",
    Ok: "Ok",
    OldestOnTop: "Oudste bovenaan",
    OneDrive: "Een schijf",
    OneOrMoreFilesLockedCheckedOut: "Een of meer bestanden vergrendeld/uitgecheckt",
    Open: "Open",
    OpenFileInBrowser: "Open bestand in browser",
    OpenFileLocation: "Bestandslocatie openen",
    OpenFileLocationIn: "Bestandslocatie openen in",
    OpenFolder: "Map openen",
    OpenFolderInBrowser: "Open locatie in browser",
    OpenIn: "Openen in",
    OpenOnlineDocumentWith: "Open het document in",
    OptionalComment: "Voeg een opmerking toe (optioneel)",
    Options: "Opties",
    OriginalSubject: "Origineel onderwerp",
    OutlookSettings: "Outlook-instellingen",
    Overview: "Overzicht",
    Overwrite: "Bestaande bestanden overschrijven/versieren",
    OverwriteRequired: "Wijzig de conflicterende bestandsnaam(en) of kies de optie om bestaande bestanden te overschrijven/versieren.",
    Owner: "Eigenaar",
    Participants: "Deelnemers",
    PeopleYouChoose: "Mensen die jij kiest",
    Permissions: "Rechten",
    Pinned: "Vastgezet",
    PinnedItemsShownHere: "Vastgezette items worden hier getoond.",
    PinThisFile: "Pin dit bestand",
    PinThisFolder: "Pin deze locatie",
    PleaseSelectSomeoneShare: "Selecteer iemand om mee te delen",
    OnlyShareWithinOrganization: "U kunt alleen binnen uw organisatie delen.",
    OnlyShareWithExistingGuests: "U kunt alleen delen met gasten die al in uw organisatie bestaan.",
    Preferences: "Voorkeuren",
    PreparingCopy: "Kopiëren voorbereiden...",
    PreparingMove: "Verplaatsing voorbereiden...",
    PreviewNotAvailable: "Voorvertoning niet ondersteund of niet beschikbaar.",
    PriceLinkText: "Onze prijzen kunt u hier bekijken.",
    PrivacySensitiveCheckError: "Fout bij controleren op privacygevoelige gegevens",
    PrivacySensitiveChecking: "Controleren op privacygevoelige gegevens",
    PrivacySensitiveDataFound: "Privacygevoelige gegevens gevonden",
    PrivacySensitiveDataNotChecked: "Privacygevoelige gegevens niet aangevinkt",
    PrivacySensitiveDataNotFound: "Geen privacygevoelige gegevens gevonden",
    PrivacySensitiveDisplay: "Privacygevoelig",
    PrivacySensitiveRedact: "Privacygevoelige gegevens redigeren",
    Private: "Privaat",
    Progress: "Voortgang",
    Properties: "Eigenschappen",
    Publish: "Publiceren",
    PublishedMajorVersion: "Huidige gepubliceerde primaire versie",
    QuickAccess: "Snelle toegang",
    ReadMore: "Lees Meer...",
    ReadOnly: "Alleen-lezen",
    Reason: "Reden",
    Reassign: "Opnieuw toewijzen",
    ReassignTo: "Opnieuw toewijzen aan",
    Received: "Ontvangen",
    Recent: "Recent",
    RecentItemsShownHere: "Recente items worden hier getoond.",
    RecentlyEditYou: "Je hebt dit onlangs bewerkt",
    RecentlyOpened: "Onlangs geopend",
    RecentlyOpenedYou: "Je hebt dit onlangs geopend",
    Recheck: "Opnieuw controleren",
    Recipients: "Ontvangers",
    RecipientsRequired: "Geadresseerde vereist",
    RecipientsRequiredMessage: "Minimaal één geadresseerde vereist.",
    Recommended: "Aanbevolen",
    Redact: "Redigeren",
    References: "Referenties",
    Refresh: "Vernieuwen",
    Reject: "Afwijzen",
    Relevance: "Relevantie",
    Remove: "Verwijderen",
    RemoveFromRecent: "Verwijderen uit recent",
    RemoveFromSuggestions: "Verwijderen uit suggesties",
    Rename: "Automatisch hernoemen",
    RenameOnly: "Hernoemen",
    RenameTextFileOption: "Je hebt bestandsnamen die al in deze map staan. Specificeer een optie.",
    Replace: "Vervangen",
    ReplaceFile: "Bestand vervangen",
    ReplacementFileRequired: "Vervangend bestand vereist.",
    ReplacementFileRequiredMessage: "Selecteer een vervangend bestand uit de lijst met beschikbare bestanden of door naar een bestand te bladeren.",
    ReplaceOnly: "Vervangen",
    ReplyTo: "Antwoord aan",
    RequestAccess: "Toegang aanvragen",
    Requester: "Aanvrager",
    RequestTrial: "Vraag een gratis proefversie aan",
    RequestTrialText: "Met onze proefversie kunt u Docubird gratis uitproberen. Voor een goede werking van Docubird is het belangrijk te weten hoe u SharePoint en Teams heeft geïmplementeerd.",
    Required: "Vereist",
    Reset: "Annuleren",
    ResetToDefault: "Standaard herstellen",
    Restoring: "Herstellen",
    RetrievingFolders: "Mappen ophalen",
    RetrievingFoldersAndFiles: "Ophalen van bestanden en mappen",
    RetrievingInfo: "Informatie ophalen",
    RetryAfter: "Probeer het opnieuw na een paar minuten",
    Save: "Opslaan",
    SaveAll: "Alles opslaan",
    SaveAndSend: "Opslaan en versturen",
    SaveAsPdf: "Opslaan als pdf",
    SaveAsPDFQuestion: "Opslaan als PDF?",
    SaveFormat: "Opslagformaat",
    SaveFormatDefault: "Standaard opslagformaat",
    SaveFormatEmailAsPdf: "E-mails als PDF",
    SaveFormatEverythingAsPdf: "Alles als PDF",
    SaveFormatInfo: "Alleen ondersteunde bestandstypen (zoals Office-documenten en e-mails) kunnen naar PDF worden geconverteerd. Overige bestanden behouden hun oorspronkelijke indeling. De documentlijst toont het resulterende type per bestand.",
    SaveFormatOriginal: "Originele indelingen behouden",
    SaveEmails: "E-mail(s) opslaan",
    SaveEmailsConfirmBody: "Na het klikken op de \"OK\" knop, wordt u doorverwezen naar het startscherm om een locatie te kiezen waar u de e-mails wilt opslaan.",
    SaveEntireFolder: "Gehele map opslaan",
    SaveInProgress: "Bezig met opslaan ...",
    SaveMail: "Deze mail opslaan?",
    SaveOnSend: "Opslaan na sturen",
    SaveProperties: "Eigenschappen opslaan",
    SaveSelected: "Geselecteerde e-mail(s) opslaan",
    SaveSelectedFiles: "Geselecteerde bestanden opslaan",
    SaveSelection: "Selectie opslaan",
    SaveTo: "Opslaan naar ",
    SaveToAnotherLocation: "Opslaan op een andere locatie",
    SavingDisabled: "Opslaan uitgeschakeld",
    SavingFile: "Bestand opslaan",
    SavingFiles: "Bestanden opslaan",
    SavingFilesNotAllowed: "Het opslaan van bestanden op deze locatie is niet toegestaan",
    Search: "Zoeken",
    SearchAllDocuments: "Alle documenten doorzoeken",
    SearchDescription: "Zoeken naar een specifieke site",
    SearchFields: "Zoekvelden",
    SearchingContent: "Zoeken naar inhoud...",
    SearchingFor: "Zoeken naar...",
    SearchResults: "Zoekresultaten",
    SearchResultsRetrieval: "Zoekresultaten ophalen ...",
    SearchSectionFilter: "Zoek {section} filters",
    Select: "Selecteer",
    SelectAction: "Selecteer actie",
    SelectAFile: "Selecteer een bestand",
    SelectAll: "Selecteer alles",
    SelectDestinationDirectory: "Kies een doelmap.",
    SelectDestinationDirectoryConfirmCopy: "Weet u zeker dat u {amount} items van {source} wilt kopiëren naar de huidige map?",
    SelectDestinationDirectoryConfirmMove: "Weet u zeker dat u {amount} items van {source} naar de huidige map wilt verplaatsen?",
    Selected: "Geselecteerd",
    SelectedFile: "Geselecteerd bestand",
    SelectItemsToSave: "Selecteer items om op te slaan",
    SelectOption: "Kies een optie",
    SelectSaveLocation: "Selecteer een opslaglocatie",
    SelectSensitivityLabel: "Selecteer een gevoeligheidslabel",
    SelectSpecificDates: "Specifieke datums selecteren",
    SelectTerm: "Selecteer term",
    Send: "Versturen",
    SendOnSaveFailed: "Uw bestand is opgeslagen, maar de e-mail kon niet automatisch worden verzonden. Verstuur deze handmatig.",
    Sending: "Bezig met verzenden",
    Sensitivity: "Gevoeligheid",
    Share: "Delen",
    ShareWithGroup: "Delen met groep",
    ShareWithGroupDescription: "Maak een link naar de geselecteerde bestanden in dezelfde bibliotheek op de geselecteerde groepssites.",
    ShareWithGroupSelectAll: "Alles selecteren",
    ShareWithGroupSharing: "Delen met {0} van {1} sites",
    ShareWithGroupResultShared: "Gedeeld met {0} van {1} sites",
    ShareWithGroupResultSharedUpdated: "Gedeeld met {0} van {1} sites, {2} bijgewerkt",
    ShareWithGroupResultNone: "Er is niets gedeeld",
    ShareWithGroupPartial: "Gedeeld met gedeeltelijke metadata",
    ShareWithGroupNoLibrary: "Geen overeenkomende bibliotheek",
    ShareWithGroupNoLibraryNamed: "Geen overeenkomende bibliotheek ({0})",
    ShareWithGroupFailed: "Mislukt",
    ShareWithGroupNoPermission: "Geen machtiging op deze site",
    ShareWithGroupSeedUnavailable: "Het bronbestand of de bronbibliotheek kon niet worden gelezen",
    ShareWithGroupSeedsUnresolved: "{0} van {1} bestanden konden niet worden gevonden; er is niets gedeeld",
    ShareWithGroupSites: "Groepssites",
    ShareWithGroupOutsideLibrary: "Bestand bevindt zich niet in zijn bibliotheek",
    ShareWithGroupLinkWithoutSharing: "Link zonder delen",
    ShareWithGroupFilesDone: "{0} van {1} bestanden",
    ShareWithGroupNotVisible: "Link niet zichtbaar voor anderen (kon niet worden ingecheckt of gepubliceerd)",
    ShareWithGroupNameInUse: "Een andere link gebruikt deze naam al",
    ShareWithGroupAwaitingApproval: "Wacht op goedkeuring",
    ShareWithGroupRenamed: "Opgeslagen als {0}",
    Shared: "Delen",
    SharedBy: "Gedeeld door",
    SharedItemsShownHere: "Gedeelde items verschijnen hier.",
    SharedLinkSuccessfullyCopied: "link(s) succesvol gekopieerd.",
    SharedMailboxMultiSelectSaveUnavailable: "Deze e-mails staan in een gedeelde mailbox die niet kon worden vastgesteld en kunnen daarom niet samen worden opgeslagen. Open eerst één e-mail uit de gedeelde mailbox en selecteer de e-mails daarna opnieuw.",
    SharedMailboxes: "Gedeelde mailboxen",
    SharedThisItem: "hebt dit item gedeeld",
    SharedWith: "Gedeeld met",
    ShareLinkWith: "Deel de link met",
    ShareLinkAccessDenied: "U hebt geen toestemming om een deellink voor dit item te maken, of delen is uitgeschakeld voor deze site.",
    ShareLinkSlowNotice: "De deellink wordt gemaakt. SharePoint reageert traag, dit kan enkele minuten duren. Als u dit venster sluit, wordt het geannuleerd.",
    ShareLinkTimedOut: "SharePoint heeft de deellink niet op tijd gemaakt. Probeer het opnieuw of deel het bestand vanuit SharePoint.",
    ShareLinkReadyToCopy: "De link is klaar. Klik op Link kopiëren om hem te kopiëren, of kopieer hem hieronder.",
    ShareMailMayNotBeSent: "De e-mail is mogelijk niet verzonden. Controleer uw Verzonden items voordat u het opnieuw probeert.",
    ShareMailSlowNotice: "Het verzenden van de e-mail duurt langer dan normaal.",
    SharepointDocumentLibrary: "Documentbibliotheek",
    SharePointDocumentSet: "Documentenset",
    SharepointFolder: "Map",
    SharePointHubSite: "Hubsite",
    SharepointSite: "Site",
    SharepointSubsite: "Subsite",
    ShareToTeams: "Delen in Teams",
    ShareWith: "Delen met",
    ShareWithPeople: "Mensen om mee te delen",
    ShowAllColumns: "Alle kolommen tonen",
    ShowDateRangeSlider: "Toon datumbereik schuif",
    ShowLess: "Laat minder zien",
    ShowMore: "Laat meer zien",
    ShowPinned: "Toon vastgezet",
    ShowPreview: "Toon voorbeeld",
    ShowRecent: "Toon recent",
    ShowShared: "Toon delen",
    SigningIn: "Inloggen ...",
    SigningRequest: "Ondertekenverzoek",
    SigningRequestCreated: "Ondertekenverzoek aangemaakt",
    SigningRequestError: "Ondertekenverzoek misluktd",
    SignInWithDifferentAccount: "Login met een ander account",
    SitePermissions: "Sitemachtigingen",
    Sites: "Sites",
    SitesFollowedShownHere: "Sites die u volgt worden hier getoond.",
    Size: "Groote",
    SmallestOnTop: "Kleinste bovenaan",
    SortBy: "Sorteren op",
    SortOrder: "Sorteervolgorde",
    Status: "Toestand",
    Strict: "Strikt",
    StrictSearchInfo: "Toon alleen resultaten waarvan de naam de zoekterm bevat.",
    Subject: "Onderwerp",
    SubmitForApproval: "Indienen voor goedkeuring",
    SubscriptionExpired: "Je Docubird-licentie is verlopen. Neem contact op met je applicatiebeheerder om deze te verlengen via Microsoft.",
    SubscriptionInvalid: "Er zijn binnen deze tenant geen vrije Docubird-licenties beschikbaar. Neem contact op met je applicatiebeheerder om licenties vrij te maken via {admin-url-placeholder} of om extra licenties aan te schaffen via Microsoft.",
    SubscriptionUpgradeRequired: "Uw huidige licentie geeft geen toegang tot Docubird DMS. Neem contact op met uw applicatiebeheerder om een licentie-upgrade aan te vragen.",
    Subsites: "Subsites",
    Success: "Succes",
    SuggestedContacts: "Voorgestelde contacten",
    SuggestedItemsShownHere: "Voorgestelde locaties worden hier getoond.",
    SuggestedPeople: "Voorgestelde mensen",
    SuggestedValues: "Voorgestelde waarden",
    Suggestions: "Suggesties",
    TaxonomyPickerExpandTitle: "Vouw deze termenset uit",
    TaxonomyPickerInLabel: "in",
    TaxonomyPickerInvalidTerms: "Ongeldige term(en): {0}",
    TaxonomyPickerMenuTermSet: "Menu voor Term Set",
    TaxonomyPickerNoTerms: "Termenset bevat geen termen",
    TaxonomyPickerTermSetLabel: "Termijn ingesteld",
    TaxonomyPickerTermsNotFound: "De volgende geselecteerde term (en) zijn niet gevonden in de term store: {0}",
    TeamsChannel: "Teams-kanaal",
    TeamsChannelNotLoaded: "De bestandslocatie van dit kanaal is nog niet ingericht.",
    TeamsFolder: "Teams-map",
    TeamsSite: "Teams-site",
    Templates: "Sjablonen",
    TessActiveProjects: "Actieve projecten",
    TessCompletedProjects: "Afgeronde projecten",
    TessConceptProjects: "Concept projecten",
    TessFolders: "Dossiers",
    TessShowAllAccounts: "Alle accounts tonen",
    TessShowContactAccounts: "Accounts van contact tonen",
    ThemeDark: "Donker",
    ThemeFollowingSystem: "Volgt Office-thema — momenteel {0}",
    ThemeLight: "Licht",
    ThemeSystem: "Systeem",
    Title: "Titel",
    TitleAutoSet: "[Automatisch ingesteld op onderwerp / bestandsnaam]",
    To: "Tot",
    ToDestination: "naar",
    TopLevelItems: "Hoofdniveau Items",
    Trending: "Trending",
    TrialExpiredText: "Uw gratis proefperiode van 30 dagen is verlopen. Wilt u Docubird blijven gebruiken?",
    Type: "Type",
    UnableToAppendLinkTryAgain: "Kan geen deelbare link bijvoegen! Probeer het a.u.b. opnieuw!",
    UnableToAttach: "E-mailbijlagen kunnen niet worden bijgevoegd!",
    UnableToAttachTryAgain: "E-mailbijlagen kunnen niet worden bijgevoegd! Probeer het a.u.b. opnieuw!",
    UnableToRetrieveFile: "Kan het huidige bestand niet ophalen! Probeer het a.u.b. opnieuw!",
    UnableToRetrieveTeams: "We kunnen uw teamsites niet ophalen",
    Unassigned: "Niet toegewezen",
    Unknown: "Onbekend",
    UnpinFile: "Unpin dit bestand",
    UnpinFolder: "Unpin deze locatie",
    Unpublish: "Depubliceren",
    UpdateIndividualFile: "Individueel bestand bijwerken",
    UpdateIndividualFileMetaData: "Update individuele bestandseigenschappen",
    Upload: "Uploaden",
    UploadToHix: "Uploaden naar HIX",
    ScanCustomFields: "Scannen op aangepaste velden",
    ScanCustomFieldsFailed: "Scan van aangepaste velden mislukt",
    ScanCustomFieldsNoFiles: "Selecteer sjabloonbestanden om te scannen, of wis de selectie om de hele bibliotheek te scannen",
    ScanCustomFieldsScanning: "Sjablonen scannen…",
    SuggestPlaceholders: "Placeholders voorstellen (AI)",
    SuggestPlaceholdersTitle: "AI-placeholdervoorstellen",
    SuggestPlaceholdersInstruction: "Optionele instructie (bijv. 'gebruik klantvelden voor het adresblok')",
    SuggestPlaceholdersRun: "Voorstellen",
    SuggestPlaceholdersApply: "Geselecteerde toepassen",
    SuggestPlaceholdersEmpty: "Geen voorstellen gevonden voor dit sjabloon.",
    SuggestPlaceholdersRejected: "Niet toepasbaar",
    SuggestPlaceholdersReplaceAll: "Alles vervangen",
    SuggestPlaceholdersHeaderBadge: "in kop-/voettekst",
    SuggestPlaceholdersApproxLayout: "Indeling bij benadering — open in Word voor exacte plaatsing",
    SuggestPlaceholdersAppliedCount: "{0} van {1} placeholders toegepast",
    SuggestPlaceholdersSkippedOne: "Overgeslagen",
    SuggestPlaceholdersNoneApplied: "Er konden geen placeholders worden toegepast — het sjabloon is niet gewijzigd.",
    SuggestPlaceholdersUndo: "Ongedaan maken",
    SuggestPlaceholdersReverted: "Teruggezet — het sjabloon is weer zoals het was voordat de wijzigingen werden toegepast. Beide stappen blijven in de versiegeschiedenis staan.",
    SuggestPlaceholdersUndoFailed: "Het sjabloon kon niet worden teruggezet — herstel versie {0} via de versiegeschiedenis.",
    SuggestPlaceholdersRevertedStale: "Teruggezet, maar het sjabloon kon daarna niet opnieuw worden gecontroleerd. Voer Voorstellen opnieuw uit voordat u toepast.",
    SuggestPlaceholdersRevertScanFailed: "de aangepaste velden konden na het terugzetten niet opnieuw worden gescand — scan dit sjabloon opnieuw om ze bij te werken",
    SuggestPlaceholdersSelectOne: "Selecteer één sjabloonbestand.",
    SuggestPlaceholdersTruncated: "Het sjabloon is lang; voorstellen dekken alleen het eerste deel.",
    SuggestPlaceholdersPreviousSlide: "Vorige dia",
    SuggestPlaceholdersNextSlide: "Volgende dia",
    SuggestPlaceholdersPinnedOccurrence: "Voorkomen {0} van {1}",
    ScanCustomFieldsScanned: "sjablonen gescand",
    ScanCustomFieldsWithFields: "met aangepaste velden",
    ScanCustomFieldsSkipped: "overgeslagen",
    ScanCustomFieldsSkippedHeader: "Overgeslagen sjablonen (niet gescand)",
    UnfilledColumnPlaceholdersWarning: "Placeholders zonder overeenkomende kolom in deze bibliotheek",
    UnfilledCrmPlaceholdersWarning: "Klant-placeholders (CRM) die niet ingevuld konden worden",
    CustomFieldsSection: "Aangepaste velden",
    CustomFieldsMissingWarning: "Sommige aangepaste velden zijn niet ingevuld — scan de sjabloonbibliotheek opnieuw",
    CustomFieldsUnusedWarning: "Sommige waarden kwamen niet overeen met de aangepaste velden van het sjabloon — scan de sjabloonbibliotheek opnieuw als het sjabloon is gewijzigd",
    HixClient: "HIX-klant",
    HixSearchClient: "Zoek een klant",
    HixUploadType: "Uploadtype",
    HixUploadTypeGeneric: "Upload bestand(en)",
    HixFilesToUpload: "Bestanden om te uploaden",
    HixMaxFilesWarning: "Je kunt maximaal 6 bestanden naar een HIX-taak uploaden. Beperk je selectie.",
    HixNoSupportedFiles: "Geen van de geselecteerde bestanden heeft een type dat HIX accepteert.",
    HixUnsupportedFilesWarning: "Deze bestanden hebben een type dat HIX niet accepteert en worden overgeslagen:",
    HixUploadSuccess: "Bestanden geüpload naar HIX.",
    HixUploadFailed: "Uploaden naar HIX is mislukt.",
    HixSomeFilesFailed: "Sommige bestanden konden niet worden geüpload:",
    HixOpenTask: "Open de taak in HIX",
    UploadCompletedSuccessfully: "Upload succesvol afgerond",
    Uploaded: "Geüpload",
    UploadFiles: "Upload bestanden",
    Uploading: "Uploaden",
    UserChangingRole: "Gebruikersrol wijzigen",
    UserRemove: "Gebruiker verwijderen",
    UsersAddError: "Er is een fout opgetreden bij het toevoegen van een of meer gebruikers",
    ValuesNotFound: "waarden niet gevonden",
    VerifyingFiles: "Bestanden verifiëren",
    Version: "Versie",
    VersionConfirmDeleteAllMessage: "Weet u zeker dat u alle versies wilt verwijderen?",
    VersionConfirmDeleteAllMinorMessage: "Weet u zeker dat u alle secundaire versies wilt verwijderen?",
    VersionDelete: "Verwijderen",
    VersionHistory: "Versie geschiedenis",
    VersionMajorPublished: "Primaire versie (gepubliceerd)",
    VersionMinorDraft: "Secundaire versie (concept)",
    VersionMinorOverwrite: "Overschrijf de huidige secundaire versie",
    VersionRestore: "Herstellen",
    VersionsDeleteAll: "Alle versies verwijderen",
    VersionsDeleteMinors: "Secundaire versies verwijderen",
    VersionStatusApproved: "Goedgekeurd - Dit item wordt zichtbaar voor alle gebruikers",
    VersionStatusPending: "In behandeling - Dit item blijft zichtbaar voor de maker en alle gebruikers die conceptitems kunnen zien",
    VersionStatusRejected: "Afgewezen - Dit item wordt alleen teruggestuurd naar de maker",
    VersionView: "Weergave",
    ViewPendingApprovalsWindow: "Bekijk alle lopende goedkeuringen in een apart venster.",
    Views: "Weergave",
    Welcome: "Welkom",
    WelcomeForAdmins: "Voor beheerders",
    WelcomeForUsers: "Voor gebruikers",
    WelcomeGoToDocubird: "Naar Docubird",
    WelcomeLoginText: "Meld u aan bij Microsoft 365",
    WelcomeOpened: "Geopend",
    WelcomeOpensInNewWindow: "{placeholder} (opent in een nieuw venster)",
    WelcomeOptionDirect: "Direct naar Docubird",
    WelcomeOptionSetup: "Richt Docubird in",
    WelcomeOptionTour: "Bekijk de rondleiding",
    WelcomeSubtitle: "Waar wil je beginnen?",
    WelcomeText: "Docubird is een Microsoft 365 add-in voor het stroomlijnen van document management in SharePoint, OneDrive en Teams.",
    WelcomeTitle: "Welkom bij {placeholder}",
    WrongUserPermissionsSave: "Je hebt niet de vereiste rechten om bestanden op deze locatie op te slaan.",
    WrongUserPermissionsUpdate: "Je hebt niet de vereiste rechten om bestanden op deze locatie bij te werken.",
    Yes: "Ja",
    You: "U"
  },
  de: {
    AccessDenied: "Zugriff verweigert",
    AccessRevoked: "Ihr Zugang für {placeholder} wurde widerrufen",
    Account: "Konto",
    AccountDeactivated: "Konto für {placeholder} wurde deaktiviert. Bitte wenden Sie sich für Unterstützung an Ihren Administrator.",
    ActionFailed: "Aktion fehlgeschlagen. Bitte versuchen Sie es später erneut.",
    ActionSucceed: "Aktion erfolgreich!",
    Add: "Hinzufügen",
    AddAttachment: "Als Anhänge",
    AddEmail: "Zur E-Mail hinzufügen",
    AddFiles: "Dateien hinzufügen",
    AddFilesAdditional: "Zusätzliche Dateien hinzufügen",
    AddShareableLink: "Als Links",
    AdvancedSearch: "Erweiterte Suche",
    All: "Alle",
    AllAlt: "Alle",
    AllDocuments: "Alle Dokumente",
    AllDocumentsCapReached: "Es werden {placeholder} Dokumente angezeigt — das Limit für diese Ansicht. Spätere Zeilen können unvollständig sein: Einige Bibliotheken wurden nicht vollständig gelesen. Öffnen Sie eine Bibliothek oder nutzen Sie die Suche bzw. einen Filter, um alles zu sehen.",
    AllowApprovals: "Meine Genehmigungen aktivieren",
    AllowApprovalsMessage: "Ermöglichen Sie Docubird den Zugriff auf Ihre Genehmigungsdaten.",
    AlreadyAssigned: "Bereits diesem Genehmiger zugewiesen",
    AlreadyExists: "Bereits vorhanden",
    AndSend: "und senden",
    Anyone: "Irgendjemand",
    App: "app",
    Appearance: "Darstellung",
    Apply: "Anwenden",
    Approval: "Genehmigung",
    ApprovalCenter: "Aufgaben",
    ApprovalRequestNotAllowedOwner: "Die Genehmigungsanfrage darf nicht an den Genehmigungsinhaber weitergeleitet werden.",
    ApprovalsLoading: "Genehmigungen werden geladen...",
    ApprovalsShownHere: "Genehmigungen werden hier angezeigt.",
    Approve: "Genehmigen",
    Approvers: "Genehmiger",
    Ascending: "Aufsteigend",
    AsPdf: "als PDF",
    Attachments: "Anhänge",
    AttachmentsSelected: "ausgewählte Anhänge",
    AttentionSaveModeActive: "Achtung: bitte beachten Sie, dass Sie noch im E-Mail-Speichermodus sind!",
    AutoFolderCreationNoContent: "Nutzen Sie das Suchfeld oben, um Dokumente und Ordner zu finden.",
    Automation: "Automatisierung",
    AutomationFlowDescription: "Beschreibung des Automatisierungsprozesses",
    AutomationFlowName: "Name des Automatisierungsprozesses",
    AutomationFlowNotSelected: "Kein Automatisierungsprozess ausgewählt",
    AutomationFlowRequest: "Anfrage zum Automatisierungsprozess",
    AutomationFlowRequestError: "Automatisierungsanfrage fehlgeschlagen",
    AutomationFlowRequestSuccess: "Automatisierungsanfrage erfolgreich gesendet",
    AutoOpenDocubird: "Docubird automatisch für dieses Dokument öffnen?",
    AutoRemoveMailItemAttachments: "Anhänge beim Speichern des E-Mail-Elements entfernen",
    AutoSelectAttachments: "Anhänge automatisch auswählen",
    AutoSetEmailProperty: "[Automatisch auf E-Mail-Eigenschaft '{emailProperty}' gesetzt]",
    AvailableFiles: "Verfügbare Dateien",
    Back: "Zurück",
    BackToWork: "Zurück zur Arbeit",
    Bcc: "Bcc",
    BlockDownload: "Download blockieren",
    Browser: "Browser",
    By: "von",
    Cancel: "Abbrechen",
    CancelApproval: "Genehmigung abbrechen",
    CancelAssignment: "Aufgabe abbrechen",
    CancelAssignmentConfrimMessage: "Sind Sie sicher, dass Sie die Zuweisung abbrechen möchten?",
    Cancelled: "Abgebrochen",
    CanEditMakesChanges: "Kann bearbeiten - Änderungen vornehmen",
    CanViewCannotMakeChanges: "Kann anzeigen - Kann keine Änderungen vornehmen",
    Categories: "Kategorien",
    Cc: "Cc",
    Channels: "Kanäle",
    CheckedOutBy: "Ausgecheckt von",
    CheckedOutByYou: "Sie haben diesen Artikel ausgecheckt",
    CheckIn: "Einchecken",
    CheckOut: "Auschecken",
    ChooseVersion: "Version auswählen",
    Clear: "Löschen",
    ClearFilter: "Filter löschen",
    ClearSearch: "Suche löschen",
    ClientGroup: "Kundengruppe",
    ClientGroupSitesCapped: "Dokumente aus {0} von {1} Seiten der Kundengruppe werden angezeigt",
    ClientGroupSearchPartial: "Einige Seiten der Kundengruppe konnten nicht durchsucht werden.",
    Columns: "Spalten",
    ClipboardBlockedInstructions: "Der Zugriff auf die Zwischenablage ist blockiert. Bitte erlauben Sie den Zugriff auf die Zwischenablage in den Browsereinstellungen und versuchen Sie es erneut, oder kopieren Sie die generierten Link(s) unten manuell.",
    Close: "Schließen",
    Comment: "Kommentar",
    Complete: "Fertig",
    Confirm: "Bestätigen",
    ConfirmDeleteDocuments: "Sind Sie sicher, dass Sie {placeholder} Dokument(e) löschen möchten? Sie werden in den Papierkorb verschoben.",
    ConfirmDeleteMailbox: "Sind Sie sicher, dass Sie {mailbox} löschen möchten?",
    ConfirmPublish: "Möchten Sie veröffentlichen?",
    ContactAdministrator: "Bitte wenden Sie sich zur Unterstützung an Ihren Administrator.",
    ContactUs: "Bitte zögern Sie nicht, uns für ein passendes Angebot zu kontaktieren.",
    ContentType: "Inhaltstyp",
    ContentTypes: "Inhaltstypen",
    Continue: "Fortsetzen",
    ConversationIndex: "Gesprächsindex",
    ConversationTopic: "Gesprächsthema",
    ConvertEmailToPdf: 'E-Mail beim Speichern in PDF umwandeln',
    ConvertToPdf: 'In PDF konvertieren',
    Copied: "Kopiert",
    CopyAll: "Alles kopieren",
    CopyingItems: "Elemente werden kopiert...",
    CopyItems: "Elemente kopieren",
    CopyLink: "Link kopieren",
    CopyProgress: "Kopierfortschritt",
    CopyProgressCounter: "{completed} von {total} Elementen kopiert",
    CopyTo: "Kopieren nach",
    Create: "Erstellen",
    Created: "Erstellt",
    CreateEmail: "E-Mail erstellen",
    CreateEmailWithAttachment: "E-Mail mit Anhang erstellen",
    CreateEmailWithLink: "E-Mail mit Link erstellen",
    CreateWithAttachments: "Mit Anhängen",
    CreateWithShareableLinks: "Mit Links",
    Datasource: "Datenquelle",
    Date: "Datum",
    Default: "Standard",
    Delete: "Löschen",
    DeleteSPItemConfirmMessage: "Sind Sie sicher, dass Sie diese(n) Artikel in den Papierkorb der Website verschieben möchten?",
    Deleting: "Wird gelöscht",
    Descending: "Absteigend",
    Description: "Beschreibung",
    DeselectAll: "Auswahl aufheben",
    Details: "Details",
    DiscardCheckOut: "Auschecken verwerfen",
    Disconnect: "Trennen",
    DocumentLibraries: "Dokumentbibliotheken",
    DocumentLibrary: "Dokumentbibliothek",
    DocumentSettings: "Dokumenteinstellungen",
    DocumentSharedWithYouBy: "Dies ist das Dokument, das [person] mit Ihnen geteilt hat.",
    DocumentSharedWithYouByEmailSubject: "[person] hat \"[file_name]\" mit Ihnen geteilt.",
    DocumentShareSuccess: "\"[file_name]\" erfolgreich geteilt.",
    Done: "Fertig",
    Download: "Herunterladen",
    DownloadAsPdf: "Als PDF herunterladen",
    DownloadAsPdfFailure: "Die Datei konnte nicht in das PDF-Format konvertiert werden. Möglicherweise ist das Format der Datei falsch, sie ist zu groß oder möglicherweise beschädigt.",
    DownloadFailure: "Fehler beim Herunterladen",
    Downloading: "Wird Heruntergeladen",
    DownloadingAttachments: "Anhänge herunterladen",
    DoYouWantToCreateFolder: "Möchten Sie die E-Mails in einem neuen Ordner speichern?",
    Draft: "Entwurf",
    DueDate: "Fälligkeitsdatum",
    DueDateDescription: "Standardmäßig {days} Tage.",
    DuplicateResolved: "Ihre doppelten Dateinamen wurden geklärt. Sie können mit dem Speichern fortfahren!",
    EditXItems: "Bearbeiten Sie {itemCount} Elemente",
    EmailHeaderMapping: "Zuordnung von E-Mail-Kopfzeilen",
    Emails: "E-Mails",
    Empty: "Leer",
    EmptyColumnHint: "(leer)",
    EnableEmails: "E-Mails aktivieren",
    EnterDate: "Geben Sie ein Datum ein",
    EnterEmail: "Geben Sie Namen, E-Mails oder Benutzergruppen ein",
    EnterFolderName: "Bitte geben Sie einen Ordnernamen ein",
    EnterLinkWebPageFile: "Geben Sie den Link zur Webseite oder Datei ein",
    EntireFolderSelected: "Ganzer Ordner ausgewählt",
    Error: "Fehler",
    ErrorConnectingToServer: "Fehler bei der Verbindung zum Server",
    ErrorDeletingFiles: "Beim Löschen einer oder mehrerer Dateien ist ein Fehler aufgetreten",
    ErrorMessageGeneric: "Etwas ist schief gelaufen",
    ErrorWhileUpdatingMetadata: "Beim Aktualisieren Ihrer Metadaten ist ein Fehler aufgetreten",
    ExchangeSettings: "Exchange-Einstellungen",
    ExternalContent: "Externer Inhalt",
    FetchProgressCounter: "{total} Elemente abgerufen",
    FetchProgressCounterAll: "Alle Artikel abrufen...",
    FieldRequired: "Feld ist erforderlich",
    FileBackgroundSave: "Ihre Dateien werden im Hintergrund gespeichert...",
    FileBackgroundSaveFailure: "Etwas ist schief gelaufen",
    FileCheckoutAndOpen: "Auschecken und öffnen",
    FileCheckoutAndOpenInBrowser: "Auschecken und im Browser öffnen",
    FileCheckoutRequired: "Diese Datei muss ausgecheckt werden, bevor Änderungen vorgenommen werden können.",
    FileCount: "Anzahl Dateien",
    FileCurrentlyCheckedOut: "Diese Datei ist derzeit ausgecheckt",
    FileDeleted: "Datei nicht verfügbar",
    FileInfo: "Dateiinformationen",
    FileLocationError: "Dateiort kann nicht geöffnet werden.",
    FileLocationUnknown: "Dateiort unbekannt",
    FileName: "Dateiname",
    FileNotExist: "Datei existiert nicht mehr!",
    FileNotFound: "Datei nicht gefunden",
    FileNotSaved: "Bitte stellen Sie sicher, dass Ihre Datei lokal gespeichert wurde!",
    FileOpenReadOnly: "Als schreibgeschützt öffnen",
    FileOpenReadOnlyInBrowser: "Als schreibgeschützt im Browser öffnen",
    FilePlural: "Datei(en)",
    FileRecentlyDeleted: "Die Datei wurde gelöscht oder verschoben, oder Sie haben keinen Zugriff mehr darauf",
    Files: "Dateien",
    FileSameCheckedOut: "Eine Datei mit diesem Namen ist bereits ausgecheckt",
    FileSameLocked: "Eine Datei mit diesem Namen ist gesperrt",
    FileSameName: "Eine Datei mit diesem Namen existiert bereits",
    FileSaveSuccess: "Ihre Dateien wurden erfolgreich gespeichert",
    FileSaveSuccessSingle: "Datei erfolgreich gespeichert",
    FileSelected: "Datei ausgewählt",
    FilesNotSuccessfullyUploaded: "Die folgenden Dateien wurden nicht erfolgreich hochgeladen",
    FilesSelected: "Dateien ausgewählt",
    FilesSelectedToUpload: "Datei(en) zum Hochladen ausgewählt",
    FileVersionLimitReached: "Dateiversionenlimit erreicht",
    Filter: "Filter",
    FilterExcludesLibraries: "Durch den Filter ausgeblendet (Spalte nicht vorhanden): {placeholder}",
    FilterDateStepIn30Days: "In 30 Tagen",
    FilterDateStepIn3Months: "In 3 Monaten",
    FilterDateStepIn3MonthsOrMore: "In 3 Monaten oder mehr",
    FilterDateStepIn7Days: "In 7 Tagen",
    FilterDateStepInAYearOrMore: "In einem Jahr oder später",
    FilterDateStepLast30Days: "In den letzten 30 Tagen",
    FilterDateStepLast3Months: "In den letzten 3 Monaten",
    FilterDateStepLast7Days: "In den letzten 7 Tagen",
    FilterDateStepSince: "Seit",
    FilterDateStepSinceYesterday: "Seit gestern",
    FilterDateStepToday: "Heute",
    FilterDateStepTomorrow: "Morgen",
    FilterResults: "Filterergebnisse",
    Finalizing: "Abschließen",
    Finished: "Alles erledigt",
    Folder: "Ordner",
    FolderCreate: "Neuen Ordner erstellen",
    FolderCreateSuccess: "Der Ordner wurde erfolgreich erstellt",
    FolderDeleted: "Ordner nicht verfügbar",
    FolderName: "Ordnername",
    FolderNotExist: "Ordner existiert nicht mehr!",
    FolderRecentlyDeleted: "Der Ordner wurde gelöscht oder verschoben, oder Sie haben keinen Zugriff mehr darauf",
    Folders: "Ordner",
    FolderSameName: "Ein Ordner mit diesem Namen existiert bereits",
    FolderSameNameAutoRename: "Ein oder mehrere Ordner mit dem/den gleichen Namen sind bereits vorhanden. Der/die hochgeladene(n) Ordner wird/werden beim Hochladen automatisch umbenannt.",
    FolderSharedWithYouBy: "Dies ist der Ordner, den [person] mit Ihnen geteilt hat.",
    FolderType: "Ordnertyp",
    FollowedSites: "Verfolgte Websites",
    From: "Von",
    GenericNoResultsFoundText: "Keine Ergebnisse gefunden",
    Group: "Gruppe",
    HidePreview: "Vorschau ausblenden",
    History: "Geschichte",
    Home: "Start",
    HubAssociatedHubs: "Zugehörigen Hubwebsites",
    HubAssociatedSites: "Zugehörigen Websites",
    HubSite: "Hubwebsite",
    InactiveClient: "Inaktiver Kunde",
    Importance: "Wichtigkeit",
    IndividualFilesUpdated: "Einzelne Dateien aktualisiert",
    InReplyTo: "In Antwort auf",
    InsertAsAttachment: "Als Anhang einfügen",
    InsertAsLink: "Als Link einfügen",
    InsertFrom: "Einfügen von",
    InvalidEmail: "Ungültige E-Mail",
    Item: "Element",
    Items: "Elemente",
    ItemsSelected: "ausgewählte Elemente",
    ItemsToAddAsAttachmentsLinks: "Als {placeholder} hinzuzufügende Elemente",
    ItemsToCopy: "Zu kopierende Elemente",
    ItemsToMove: "Zu verschiebende Elemente",
    ItemToCopy: "Zu kopierendes Element",
    ItemToMove: "Zu verschiebendes Element",
    LandingPage: "Landing page",
    LargestOnTop: "Größte oben",
    LeastRelevantOnTop: "Wenigste relevant oben",
    LevelUp: "Level aufsteigen",
    LibraryPermissions: "Bibliotheksrechte",
    LicenseRequired: "Um Zugang zu {placeholder} zu haben, benötigen Sie eine kostenpflichtige Lizenz.",
    LicenseRequiredTitle: "Lizenz erforderlich",
    LimitReached: "Limit erreicht",
    Link: "Link",
    List: "Liste",
    ListItem: "Listenelement",
    ListItemPickerSelectValue: "Wert auswählen",
    Lists: "Listen",
    LoadDefaults: "Standardwerte laden",
    Loading: "Lade...",
    LoadingClientGroupSites: "Seiten der Kundengruppe werden geladen",
    LoadingEmails: "E-Mails laden",
    LoadingFilters: "Filter laden",
    LoadingInputs: "Eingaben laden",
    LoadingOnly: "Wird geladen",
    LoadingProfile: "Profil wird geladen...",
    LoadMore: "Mehr Ergebnisse laden",
    Local: "lokal",
    LibrariesFailedToLoad: "Konnte nicht geladen werden: {placeholder}",
    LibrariesExceededThreshold: "Zu groß, um so zu sortieren oder zu filtern: {placeholder}. Bitten Sie einen Administrator, einen Index für die Spalte hinzuzufügen, oder schränken Sie die Ansicht mit einer Suche ein.",
    Location: "Standort",
    Locations: "Microsoft 365-Standorte",
    LocationsView: "Speicherorte",
    MailboxAccessDenied: 'Ihr Konto ({account}) hat möglicherweise keine Berechtigung, auf die Mailbox oder dieses bestimmte Element zuzugreifen.',
    MailboxAddress: "Mailbox-Adresse",
    MailboxAlreadyAdded: "Mailbox bereits hinzugefügt",
    MailboxAuthorizing: "Mailbox autorisieren",
    Manage: "Verwalten",
    ManualClipboardCopyInstructions: "Das automatische Kopieren wurde vom Browser blockiert. Klicken Sie auf Link kopieren, um es erneut zu versuchen, oder kopieren Sie die generierten Link(s) unten manuell.",
    MaximumEmailMessagesSelected: "Maximal {amount} E-Mail-Nachrichten können gleichzeitig gespeichert werden.",
    Me: "Ich",
    Member: "Mitglied",
    Members: "Mitglieder",
    MembersAdd: "Mitglieder hinzufügen",
    MemberSelect: "Mitglied auswählen",
    MembersNotFound: "Keine Mitglieder gefunden",
    MembersNotSelected: "Keine Mitglieder ausgewählt",
    Message: "Nachricht",
    MessageComposeSaveSuccess: "Ihre Nachricht wurde erfolgreich gespeichert. Sie können dieses Fenster und Ihre Nachricht schließen, wenn diese noch geöffnet sind.",
    MessageComposeSaveSendFailed: "Ihre Nachricht wurde gespeichert, konnte aber nicht automatisch gesendet werden. Bitte senden Sie Ihre Nachricht manuell.",
    MessageComposeSaving: "Ihre Nachricht wird gespeichert und wird gesendet, sobald sie vollständig ist. Bitte warten Sie...",
    MessageId: "Nachrichten-ID",
    MetadataNotUpdated: "Dateien wurden erfolgreich gespeichert. Stellen Sie sicher, dass die Metadaten entsprechend aktualisiert wurden",
    MetadataValidationFailed: "Validierung fehlgeschlagen für",
    MinorVersions: "Nebenversionen (Entwürfe)",
    MissingMetadata: "Fehlende Metadaten",
    Modified: "Geändert",
    ModifiedBy: "Geändert von",
    More: "Mehr",
    MoreActions: "Aktionen anzeigen",
    MostRelevantOnTop: "Am relevantesten oben",
    MoveAll: "Alle verschieben",
    MoveItemDown: "Angeheftetes Element nach unten verschieben",
    MoveItems: "Elemente verschieben",
    MoveItemUp: "Angeheftetes Element nach oben verschieben",
    MoveProgress: "Fortschritt verschieben",
    MoveProgressCounter: "{completed} von {total} Elementen verschoben",
    MoveTo: "Verschieben nach",
    MovingItems: "Verschiebe Elemente...",
    MultipleFilesFoldersCopyMove: "Dateien/Ordner mit demselben Namen können nicht an denselben Ort kopiert oder verschoben werden.",
    MyApprovals: "Meine Genehmigungen",
    MyOrganization: "Meine Organisation",
    Name: "Name",
    New: "Neue",
    // Deliberately identical to New so German output is unchanged; the neuter form
    // ("Neues") would be correct for Dokument but not for Arbeitsmappe.
    NewDocument: "Neue",
    NewestOnTop: "Neueste oben",
    NewOnly: "Neu",
    No: "Nein",
    NoAppSpecificFiles: "Keine {context} Dateien gefunden.",
    NoEmailAvailable: "Keine E-Mail verfügbar",
    NoFilesSelected: "Keine Dateien ausgewählt",
    NoFiltersAvailable: "Keine Filter verfügbar",
    NoItemsFound: "Keine Elemente gefunden!",
    NoLocations: "Keine weiteren Standorte",
    NoMoreFolders: "In diesem Verzeichnis befinden sich keine Ordner!",
    NoMoreFoldersAndFiles: "Dieses Verzeichnis ist leer.",
    NoResultsFound: "Keine Ergebnisse gefunden",
    NoResultsForValue: "Keine Ergebnisse für diesen Wert",
    NoSubject: "Kein Betreff",
    NotAssignedToSite: "Sie sind keiner Website zugeordnet.",
    NotAssignedToTeam: "Sie sind Mitglied keines Teams.",
    NotWorkingOnOnlineVersion: "Sie arbeiten nicht an der Online-Version dieses Dokuments.",
    Of: "von",
    Ok: "Ok",
    OldestOnTop: "Älteste oben",
    OneDrive: "OneDrive",
    OneOrMoreFilesLockedCheckedOut: "Eine oder mehrere Dateien gesperrt/ausgecheckt",
    Open: "Öffnen",
    OpenFileInBrowser: "Datei im Browser öffnen",
    OpenFileLocation: "Dateiort öffnen",
    OpenFileLocationIn: "Dateiort öffnen in",
    OpenFolder: "Ordner öffnen",
    OpenFolderInBrowser: "Ort im Browser öffnen",
    OpenIn: "Öffnen in",
    OpenOnlineDocumentWith: "Das Dokument öffnen in",
    OptionalComment: "Einen Kommentar hinzufügen (optional)",
    Options: "Optionen",
    OriginalSubject: "Ursprünglicher Betreff",
    OutlookSettings: "Outlook-Einstellungen",
    Overview: "Überblick",
    Overwrite: "Überschreiben/Version vorhandener Dateien",
    OverwriteRequired: "Ändern Sie den/die widersprüchlichen Dateinamen oder wählen Sie die Option, vorhandene Dateien zu überschreiben/versionieren.",
    Owner: "Eigentümer",
    Participants: "Teilnehmer",
    PeopleYouChoose: "Personen, die Sie auswählen",
    Permissions: "Berechtigungen",
    Pinned: "Angepinnt",
    PinnedItemsShownHere: "Angepinnte Elemente werden hier angezeigt.",
    PinThisFile: "Diese Datei anpinnen",
    PinThisFolder: "Diesen Ort anpinnen",
    PleaseSelectSomeoneShare: "Bitte wählen Sie jemanden zum Teilen aus",
    OnlyShareWithinOrganization: "Sie können nur innerhalb Ihrer Organisation freigeben.",
    OnlyShareWithExistingGuests: "Sie können nur mit Gästen teilen, die bereits in Ihrer Organisation vorhanden sind.",
    Preferences: "Einstellungen",
    PreparingCopy: "Kopiervorgang vorbereiten...",
    PreparingMove: "Umzugsvorgang vorbereitet...",
    PreviewNotAvailable: "Vorschau nicht unterstützt oder nicht verfügbar.",
    PriceLinkText: "Unsere Preise können Sie hier einsehen.",
    PrivacySensitiveCheckError: "Fehler bei der Prüfung auf datenschutzsensible Daten",
    PrivacySensitiveChecking: "Prüfung auf datenschutzsensible Daten",
    PrivacySensitiveDataFound: "Datenschutzsensible Daten gefunden",
    PrivacySensitiveDataNotChecked: "Datenschutzsensible Daten nicht geprüft",
    PrivacySensitiveDataNotFound: "Keine datenschutzsensiblen Daten gefunden",
    PrivacySensitiveDisplay: "Datenschutzsensibel",
    PrivacySensitiveRedact: "Datenschutzsensible Daten schwärzen",
    Private: "Privat",
    Progress: "Fortschritt",
    Properties: "Eigenschaften",
    Publish: "Veröffentlichen",
    PublishedMajorVersion: "Aktuelle veröffentlichte Hauptversion",
    QuickAccess: "Schnellzugriff",
    ReadMore: "Weiterlesen...",
    ReadOnly: "Nur Lesen",
    Reason: "Grund",
    Reassign: "Neu zuweisen",
    ReassignTo: "Neu zuweisen an",
    Received: "Erhalten",
    Recent: "Kürzlich",
    RecentItemsShownHere: "Kürzliche Elemente werden hier angezeigt.",
    RecentlyEditYou: "Sie haben dies kürzlich bearbeitet",
    RecentlyOpened: "Kürzlich geöffnet",
    RecentlyOpenedYou: "Sie haben dies kürzlich geöffnet",
    Recheck: "Nochmals prüfen",
    Recipients: "Empfänger",
    RecipientsRequired: "Empfänger erforderlich",
    RecipientsRequiredMessage: "Mindestens ein Adressat ist erforderlich.",
    Recommended: "Empfohlen",
    Redact: "Schwärzen",
    References: "Referenzen",
    Refresh: "Aktualisieren",
    Reject: "Ablehnen",
    Relevance: "Relevanz",
    Remove: "Entfernen",
    RemoveFromRecent: "Aus Kürzlich entfernen",
    RemoveFromSuggestions: "Aus Vorschlägen entfernen",
    Rename: "Automatisch umbenennen",
    RenameOnly: "Umbenennen",
    RenameTextFileOption: "Sie haben Dateinamen, die in diesem Ordner bereits existieren. Bitte geben Sie eine Option an.",
    Replace: "Ersetzen/Versionieren",
    ReplaceFile: "Datei ersetzen",
    ReplacementFileRequired: "Ersatzdatei erforderlich.",
    ReplacementFileRequiredMessage: "Bitte wählen Sie eine Ersatzdatei aus der Liste der verfügbaren Dateien oder durchsuchen Sie nach einer Datei.",
    ReplaceOnly: "Ersetzen",
    ReplyTo: "Antworten an",
    RequestAccess: "Zugriff anfordern",
    Requester: "Anforderer",
    RequestTrial: "Eine kostenlose Testversion anfordern",
    RequestTrialText: "Mit unserer Testversion können Sie Docubird kostenlos ausprobieren. Damit Docubird richtig funktioniert, ist es wichtig zu wissen, wie Sie SharePoint und Teams implementiert haben.",
    Required: "Erforderlich",
    Reset: "Zurücksetzen",
    ResetToDefault: "Auf Standard zurücksetzen",
    Restoring: "Wiederherstellen",
    RetrievingFolders: "Ordner abrufen",
    RetrievingFoldersAndFiles: "Dateien und Ordner abrufen",
    RetrievingInfo: "Informationen abrufen",
    RetryAfter: "Bitte versuchen Sie es in einigen Minuten erneut",
    Save: "Speichern",
    SaveAll: "Alle speichern",
    SaveAndSend: "Speichern und senden",
    SaveAsPdf: "Als pdf speichern",
    SaveAsPDFQuestion: "Als PDF speichern?",
    SaveFormat: "Speicherformat",
    SaveFormatDefault: "Standard-Speicherformat",
    SaveFormatEmailAsPdf: "E-Mails als PDF",
    SaveFormatEverythingAsPdf: "Alles als PDF",
    SaveFormatInfo: "Nur unterstützte Dateitypen (z. B. Office-Dokumente und E-Mails) können in PDF konvertiert werden. Andere Dateien behalten ihr ursprüngliches Format. Die Dokumentliste zeigt das resultierende Format pro Datei.",
    SaveFormatOriginal: "Originalformate beibehalten",
    SaveEmails: "E-Mail(s) speichern",
    SaveEmailsConfirmBody: "Nach dem Klicken auf den \"OK\"-Button werden Sie zum Startbildschirm weitergeleitet, um einen Ort auszuwählen, an dem Sie die E-Mails speichern möchten.",
    SaveEntireFolder: "Gesamten Ordner speichern",
    SaveInProgress: "Speichern läuft ...",
    SaveMail: "Diese Mail speichern?",
    SaveOnSend: "Beim Senden speichern",
    SaveProperties: "Eigenschaften speichern",
    SaveSelected: "Ausgewählte E-Mail(s) speichern",
    SaveSelectedFiles: "Ausgewählte Dateien speichern",
    SaveSelection: "Auswahl speichern",
    SaveTo: "Speichern in ",
    SaveToAnotherLocation: "In einem anderen Ort speichern",
    SavingDisabled: "Speichern deaktiviert",
    SavingFile: "Datei speichern",
    SavingFiles: "Dateien speichern",
    SavingFilesNotAllowed: "Das Speichern von Dateien an diesem Ort ist nicht erlaubt",
    Search: "Suchen",
    SearchAllDocuments: "Alle Dokumente durchsuchen",
    SearchDescription: "Suche nach einer spezifischen Site",
    SearchFields: "Suchfelder",
    SearchingContent: "Inhalte suchen...",
    SearchingFor: "Suchen nach...",
    SearchResults: "Suchergebnisse",
    SearchResultsRetrieval: "Suchergebnisse abrufen...",
    SearchSectionFilter: "Suche {section} Filter",
    Select: "Alles auswählen",
    SelectAction: "Aktion auswählen",
    SelectAFile: "Eine Datei auswählen",
    SelectAll: "Select all",
    SelectDestinationDirectory: "Bitte wählen Sie ein Zielverzeichnis.",
    SelectDestinationDirectoryConfirmCopy: "Sind Sie sicher, dass Sie {amount} Elemente von {source} in das aktuelle Verzeichnis kopieren möchten?",
    SelectDestinationDirectoryConfirmMove: "Sind Sie sicher, dass Sie {amount} Elemente von {source} in das aktuelle Verzeichnis verschieben möchten?",
    Selected: "Ausgewählt",
    SelectedFile: "Ausgewählte Datei",
    SelectItemsToSave: "Zu speichernde Elemente auswählen",
    SelectOption: "Eine Option auswählen",
    SelectSaveLocation: "Wählen Sie einen Speicherort",
    SelectSensitivityLabel: "Wählen Sie ein Sensitivitätsetikett",
    SelectSpecificDates: "Bestimmte Daten auswählen",
    SelectTerm: "Begriff auswählen",
    Send: "Senden",
    SendOnSaveFailed: "Ihre Datei wurde gespeichert, aber die E-Mail konnte nicht automatisch gesendet werden. Bitte senden Sie sie manuell.",
    Sending: "Senden",
    Sensitivity: "Sensitivität",
    Share: "Teilen",
    ShareWithGroup: "Mit Gruppe teilen",
    ShareWithGroupDescription: "Erstellt einen Link zu den ausgewählten Dateien in derselben Bibliothek auf den ausgewählten Gruppenseiten.",
    ShareWithGroupSelectAll: "Alle auswählen",
    ShareWithGroupSharing: "Teilen mit {0} von {1} Seiten",
    ShareWithGroupResultShared: "Mit {0} von {1} Seiten geteilt",
    ShareWithGroupResultSharedUpdated: "Mit {0} von {1} Seiten geteilt, {2} aktualisiert",
    ShareWithGroupResultNone: "Es wurde nichts geteilt",
    ShareWithGroupPartial: "Mit unvollständigen Metadaten geteilt",
    ShareWithGroupNoLibrary: "Keine passende Bibliothek",
    ShareWithGroupNoLibraryNamed: "Keine passende Bibliothek ({0})",
    ShareWithGroupFailed: "Fehlgeschlagen",
    ShareWithGroupNoPermission: "Keine Berechtigung auf dieser Seite",
    ShareWithGroupSeedUnavailable: "Die Quelldatei oder Quellbibliothek konnte nicht gelesen werden",
    ShareWithGroupSeedsUnresolved: "{0} von {1} Dateien konnten nicht aufgelöst werden; es wurde nichts geteilt",
    ShareWithGroupSites: "Gruppenseiten",
    ShareWithGroupOutsideLibrary: "Datei befindet sich nicht in ihrer Bibliothek",
    ShareWithGroupLinkWithoutSharing: "Link ohne Freigabe",
    ShareWithGroupFilesDone: "{0} von {1} Dateien",
    ShareWithGroupNotVisible: "Link für andere nicht sichtbar (konnte nicht eingecheckt oder veröffentlicht werden)",
    ShareWithGroupNameInUse: "Ein anderer Link verwendet diesen Namen bereits",
    ShareWithGroupAwaitingApproval: "Wartet auf Genehmigung",
    ShareWithGroupRenamed: "Gespeichert als {0}",
    Shared: "Geteilt",
    SharedBy: "Geteilt durch",
    SharedItemsShownHere: "Mit Ihnen geteilte Dateien werden hier angezeigt.",
    SharedLinkSuccessfullyCopied: "Link(s) erfolgreich kopiert.",
    SharedMailboxMultiSelectSaveUnavailable: "Diese E-Mails befinden sich in einem freigegebenen Postfach, das nicht ermittelt werden konnte, und können daher nicht gemeinsam gespeichert werden. Öffnen Sie zuerst eine E-Mail aus dem freigegebenen Postfach und wählen Sie die E-Mails anschließend erneut aus.",
    SharedMailboxes: "Geteilte Postfächer",
    SharedThisItem: "Dieses Element geteilt",
    SharedWith: "Geteilt mit",
    ShareLinkWith: "Teilen Sie den Link mit",
    ShareLinkAccessDenied: "Sie haben keine Berechtigung, einen Freigabelink für dieses Element zu erstellen, oder die Freigabe ist für diese Website deaktiviert.",
    ShareLinkSlowNotice: "Der Freigabelink wird erstellt. SharePoint reagiert langsam, dies kann einige Minuten dauern. Wenn Sie diesen Bereich schließen, wird der Vorgang abgebrochen.",
    ShareLinkTimedOut: "SharePoint hat den Freigabelink nicht rechtzeitig erstellt. Versuchen Sie es erneut oder geben Sie die Datei über SharePoint frei.",
    ShareLinkReadyToCopy: "Der Link ist bereit. Klicken Sie auf Link kopieren, um ihn zu kopieren, oder kopieren Sie ihn unten.",
    ShareMailMayNotBeSent: "Die E-Mail wurde möglicherweise nicht gesendet. Prüfen Sie Ihre gesendeten Elemente, bevor Sie es erneut versuchen.",
    ShareMailSlowNotice: "Das Senden der E-Mail dauert länger als üblich.",
    SharepointDocumentLibrary: "Dokumentenbibliothek",
    SharePointDocumentSet: "Dokumentensatz",
    SharepointFolder: "Ordner",
    SharePointHubSite: "Hubwebsite",
    SharepointSite: "Site",
    SharepointSubsite: "Unterwebsite",
    ShareToTeams: "In Teams freigeben",
    ShareWith: "Teilen mit",
    ShareWithPeople: "Personen zum Teilen",
    ShowAllColumns: "Alle Spalten anzeigen",
    ShowDateRangeSlider: "Datumsbereichs-Schieberegler anzeigen",
    ShowLess: "Weniger anzeigen",
    ShowMore: "Mehr anzeigen",
    ShowPinned: "Angeheftete anzeigen",
    ShowPreview: "Vorschau anzeigen",
    ShowRecent: "Kürzlich anzeigen",
    ShowShared: "Geteiltes anzeigen",
    SigningIn: "Anmelden ...",
    SigningRequest: "Antrag auf Unterzeichnung",
    SigningRequestCreated: "Signieranforderung erstellt",
    SigningRequestError: "Signierungsanfrage fehlgeschlagen",
    SignInWithDifferentAccount: "Mit einem anderen Konto anmelden",
    SitePermissions: "Site-Berechtigungen",
    Sites: "Websites",
    SitesFollowedShownHere: "Websites, denen Sie folgen, werden hier angezeigt.",
    Size: "Größe",
    SmallestOnTop: "Kleinste oben",
    SortBy: "Sortieren nach",
    SortOrder: "Sortierreihenfolge",
    Status: "Status",
    Strict: "Streng",
    StrictSearchInfo: "Zeige nur Ergebnisse an, bei denen der Name den Suchbegriff enthält.",
    Subject: "Betreff",
    SubmitForApproval: "Zur Genehmigung einreichen",
    SubscriptionExpired: "Ihre Docubird-Lizenz ist abgelaufen. Bitte wenden Sie sich an Ihren Anwendungsadministrator, um sie über Microsoft zu verlängern.",
    SubscriptionInvalid: "In diesem Tenant sind keine kostenlosen Docubird-Lizenzen verfügbar. Wenden Sie sich an Ihren Anwendungsadministrator, um Lizenzen über {admin-url-placeholder} freizugeben oder zusätzliche Lizenzen über Microsoft zu erwerben.",
    SubscriptionUpgradeRequired: "Ihre aktuelle Lizenz beinhaltet keinen Zugriff auf Docubird DMS. Bitte wenden Sie sich an Ihren Anwendungsadministrator, um ein Lizenz-Upgrade anzufordern.",
    Subsites: "Unterwebsite",
    Success: "Erfolg",
    SuggestedContacts: "Vorgeschlagene Kontakte",
    SuggestedItemsShownHere: "Vorgeschlagene Standorte werden hier angezeigt.",
    SuggestedPeople: "Vorgeschlagene Personen",
    SuggestedValues: "Vorgeschlagene Werte",
    Suggestions: "Vorschläge",
    TaxonomyPickerExpandTitle: "Dieses Term Set erweitern",
    TaxonomyPickerInLabel: "in",
    TaxonomyPickerInvalidTerms: "Ungültige(r) Begriff(e): {0}",
    TaxonomyPickerMenuTermSet: "Menü für Term Set",
    TaxonomyPickerNoTerms: "Term Set enthält keine Begriffe",
    TaxonomyPickerTermSetLabel: "Term Set",
    TaxonomyPickerTermsNotFound: "Die nächsten ausgewählten Begriffe konnten nicht im Term Store gefunden werden: {0}",
    TeamsChannel: "Teams Kanal",
    TeamsChannelNotLoaded: "Der Speicherort für die Dateien dieses Kanals wurde noch nicht bereitgestellt.",
    TeamsFolder: "Teams Ordner",
    TeamsSite: "Teams Website",
    Templates: "Vorlagen",
    TessActiveProjects: "Aktive Projekte",
    TessCompletedProjects: "Abgeschlossene Projekte",
    TessConceptProjects: "Konzeptprojekte",
    TessFolders: "Dossiers",
    TessShowAllAccounts: "Alle Konten anzeigen",
    TessShowContactAccounts: "Kontaktkonten anzeigen",
    ThemeDark: "Dunkel",
    ThemeFollowingSystem: "Folgt dem Office-Design — aktuell {0}",
    ThemeLight: "Hell",
    ThemeSystem: "System",
    Title: "Titel",
    TitleAutoSet: "[Automatisch auf E-Mail-Betreff / Dateiname eingestellt]",
    To: "Bis",
    ToDestination: "nach",
    TopLevelItems: "Hauptebene Elemente",
    Trending: "Trend",
    TrialExpiredText: "Ihre kostenlose 30-Tage-Testversion ist abgelaufen. Möchten Sie Docubird weiterhin nutzen?",
    Type: "Typ",
    UnableToAppendLinkTryAgain: "Ein freigebbarer Link kann nicht angehängt werden! Bitte versuchen Sie es erneut!",
    UnableToAttach: "E-Mail-Anhänge können nicht angehängt werden!",
    UnableToAttachTryAgain: "E-Mail-Anhänge können nicht angehängt werden! Bitte versuchen Sie es erneut!",
    UnableToRetrieveFile: "Die aktuelle Datei konnte nicht abgerufen werden! Bitte versuchen Sie es erneut!",
    UnableToRetrieveTeams: "Wir konnten Ihre Team websites nicht abrufen",
    Unassigned: "Nicht zugewiesen",
    Unknown: "Unbekannt",
    UnpinFile: "Diese Datei lösen",
    UnpinFolder: "Diesen Ort lösen",
    Unpublish: "Zurückziehen",
    UpdateIndividualFile: "Einzelne Datei aktualisieren",
    UpdateIndividualFileMetaData: "Metadaten einer einzelnen Datei aktualisieren",
    Upload: "Hochladen",
    UploadToHix: "Zu HIX hochladen",
    ScanCustomFields: "Nach benutzerdefinierten Feldern scannen",
    ScanCustomFieldsFailed: "Scan der benutzerdefinierten Felder fehlgeschlagen",
    ScanCustomFieldsNoFiles: "Wählen Sie Vorlagendateien zum Scannen aus, oder heben Sie die Auswahl auf, um die gesamte Bibliothek zu scannen",
    ScanCustomFieldsScanning: "Vorlagen werden gescannt…",
    SuggestPlaceholders: "Platzhalter vorschlagen (KI)",
    SuggestPlaceholdersTitle: "KI-Platzhaltervorschläge",
    SuggestPlaceholdersInstruction: "Optionale Anweisung (z. B. 'Kundenfelder für den Adressblock verwenden')",
    SuggestPlaceholdersRun: "Vorschlagen",
    SuggestPlaceholdersApply: "Ausgewählte anwenden",
    SuggestPlaceholdersEmpty: "Keine Vorschläge für diese Vorlage gefunden.",
    SuggestPlaceholdersRejected: "Nicht anwendbar",
    SuggestPlaceholdersReplaceAll: "Alle ersetzen",
    SuggestPlaceholdersHeaderBadge: "in Kopf-/Fußzeile",
    SuggestPlaceholdersApproxLayout: "Layout näherungsweise — für exakte Platzierung in Word öffnen",
    SuggestPlaceholdersAppliedCount: "{0} von {1} Platzhaltern angewendet",
    SuggestPlaceholdersSkippedOne: "Übersprungen",
    SuggestPlaceholdersNoneApplied: "Es konnten keine Platzhalter angewendet werden — die Vorlage wurde nicht geändert.",
    SuggestPlaceholdersUndo: "Rückgängig",
    SuggestPlaceholdersReverted: "Zurückgesetzt — die Vorlage ist wieder in dem Zustand von vor der Anwendung der Änderungen. Beide Schritte bleiben im Versionsverlauf erhalten.",
    SuggestPlaceholdersUndoFailed: "Die Vorlage konnte nicht zurückgesetzt werden — stellen Sie Version {0} über den Versionsverlauf wieder her.",
    SuggestPlaceholdersRevertedStale: "Zurückgesetzt, aber die Vorlage konnte danach nicht erneut geprüft werden. Führen Sie Vorschlagen erneut aus, bevor Sie anwenden.",
    SuggestPlaceholdersRevertScanFailed: "die benutzerdefinierten Felder konnten nach dem Zurücksetzen nicht erneut gescannt werden — scannen Sie diese Vorlage erneut, um sie zu aktualisieren",
    SuggestPlaceholdersSelectOne: "Wählen Sie eine einzelne Vorlagendatei.",
    SuggestPlaceholdersTruncated: "Die Vorlage ist lang; Vorschläge decken nur den ersten Teil ab.",
    SuggestPlaceholdersPreviousSlide: "Vorherige Folie",
    SuggestPlaceholdersNextSlide: "Nächste Folie",
    SuggestPlaceholdersPinnedOccurrence: "Vorkommen {0} von {1}",
    ScanCustomFieldsScanned: "Vorlagen gescannt",
    ScanCustomFieldsWithFields: "mit benutzerdefinierten Feldern",
    ScanCustomFieldsSkipped: "übersprungen",
    ScanCustomFieldsSkippedHeader: "Übersprungene Vorlagen (nicht gescannt)",
    UnfilledColumnPlaceholdersWarning: "Platzhalter ohne übereinstimmende Spalte in dieser Bibliothek",
    UnfilledCrmPlaceholdersWarning: "Kunden-Platzhalter (CRM), die nicht ausgefüllt werden konnten",
    CustomFieldsSection: "Benutzerdefinierte Felder",
    CustomFieldsMissingWarning: "Einige benutzerdefinierte Felder wurden nicht ausgefüllt — Vorlagenbibliothek erneut scannen",
    CustomFieldsUnusedWarning: "Einige Werte passten nicht zu den benutzerdefinierten Feldern der Vorlage — Vorlagenbibliothek erneut scannen, wenn die Vorlage geändert wurde",
    HixClient: "HIX-Kunde",
    HixSearchClient: "Nach einem Kunden suchen",
    HixUploadType: "Upload-Typ",
    HixUploadTypeGeneric: "Datei(en) hochladen",
    HixFilesToUpload: "Hochzuladende Dateien",
    HixMaxFilesWarning: "Sie können maximal 6 Dateien in eine HIX-Aufgabe hochladen. Reduzieren Sie Ihre Auswahl.",
    HixNoSupportedFiles: "Keine der ausgewählten Dateien hat einen von HIX akzeptierten Typ.",
    HixUnsupportedFilesWarning: "Diese Dateien haben einen von HIX nicht akzeptierten Typ und werden übersprungen:",
    HixUploadSuccess: "Dateien zu HIX hochgeladen.",
    HixUploadFailed: "Hochladen zu HIX fehlgeschlagen.",
    HixSomeFilesFailed: "Einige Dateien konnten nicht hochgeladen werden:",
    HixOpenTask: "Aufgabe in HIX öffnen",
    UploadCompletedSuccessfully: "Upload erfolgreich abgeschlossen",
    Uploaded: "Hochgeladen",
    UploadFiles: "Dateien hochladen",
    Uploading: "Hochladen",
    UserChangingRole: "Benutzerrolle wird geändert",
    UserRemove: "Benutzer entfernen",
    UsersAddError: "Beim Hinzufügen eines oder mehrerer Benutzer ist ein Fehler aufgetreten",
    ValuesNotFound: "Werte nicht gefunden",
    VerifyingFiles: "Dateien werden überprüft",
    Version: "Version",
    VersionConfirmDeleteAllMessage: "Möchten Sie wirklich alle Versionen löschen?",
    VersionConfirmDeleteAllMinorMessage: "Möchten Sie wirklich alle Minderheitsversionen löschen?",
    VersionDelete: "Löschen",
    VersionHistory: "Versionsverlauf",
    VersionMajorPublished: "Hauptversion (veröffentlicht)",
    VersionMinorDraft: "Minderheitsversion (Entwurf)",
    VersionMinorOverwrite: "Aktuelle Minderheitsversion überschreiben",
    VersionRestore: "Wiederherstellen",
    VersionsDeleteAll: "Alle Versionen löschen",
    VersionsDeleteMinors: "Minderheitsversionen löschen",
    VersionStatusApproved: "Genehmigt - Dieser Artikel wird für alle Benutzer sichtbar",
    VersionStatusPending: "Ausstehend - Dieser Artikel bleibt für seinen Ersteller und alle Benutzer sichtbar, die Entwurfsartikel sehen können",
    VersionStatusRejected: "Abgelehnt - Dieser Artikel wird nur an den Ersteller zurückgegeben",
    VersionView: "Anzeigen",
    ViewPendingApprovalsWindow: "Alle ausstehenden Genehmigungen in separatem Fenster anzeigen.",
    Views: "Ansichten",
    Welcome: "Willkommen",
    WelcomeForAdmins: "Für Administratoren",
    WelcomeForUsers: "Für Benutzer",
    WelcomeGoToDocubird: "Zu Docubird",
    WelcomeLoginText: "Melden Sie sich bei Microsoft 365 an",
    WelcomeOpened: "Geöffnet",
    WelcomeOpensInNewWindow: "{placeholder} (öffnet in einem neuen Fenster)",
    WelcomeOptionDirect: "Direkt zu Docubird",
    WelcomeOptionSetup: "Docubird einrichten",
    WelcomeOptionTour: "Rundgang ansehen",
    WelcomeSubtitle: "Wo möchten Sie beginnen?",
    WelcomeText: "Docubird ist ein Microsoft 365-Add-In zur Optimierung der Dokumentenverwaltung in SharePoint, OneDrive und Teams.",
    WelcomeTitle: "Willkommen bei {placeholder}",
    WrongUserPermissionsSave: "Sie haben nicht die erforderlichen Berechtigungen, um Dateien an diesem Speicherort zu speichern.",
    WrongUserPermissionsUpdate: "Sie haben nicht die erforderlichen Berechtigungen, um Dateien an diesem Speicherort zu aktualisieren.",
    Yes: "Ja",
    You: "Sie"
  }
};

export const LanguageContext = React.createContext(locales.en);

export class LocalizationModule {
  // Cached because the result is runtime-invariant (locale placeholders never
  // change), and this is read on every render / rename in the Title-sync paths.
  private static titleAutoSetVariants: string[];

  // Returns the "Title auto-set" placeholder text for every supported locale.
  // Used to detect an un-set Title regardless of the user's active language.
  static getTitleAutoSetVariants(): string[] {
    if (!this.titleAutoSetVariants) {
      this.titleAutoSetVariants = Object.values(locales)
        .map(localeStrings => localeStrings.TitleAutoSet)
        .filter(value => typeof value === "string" && value.length > 0);
    }
    return this.titleAutoSetVariants;
  }

  private static autoSetEmailPropertyPatterns: RegExp[];

  // Detects the "[Autoset to email property 'X']" placeholder in any supported
  // locale and for any property name. The placeholder is UI-only: it must never
  // be persisted as a real SharePoint column value, so save paths use this to
  // clear it when no per-email value can be resolved.
  static isAutoSetEmailPropertyPlaceholder(value: any): boolean {
    if (typeof value !== "string" || value.length === 0) {
      return false;
    }
    if (!this.autoSetEmailPropertyPatterns) {
      this.autoSetEmailPropertyPatterns = Object.values(locales)
        .map(localeStrings => localeStrings.AutoSetEmailProperty)
        .filter(template => typeof template === "string" && template.includes("{emailProperty}"))
        .map(template => {
          const escaped = template.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          return new RegExp(`^${escaped.replace("\\{emailProperty\\}", ".+?")}$`);
        });
    }
    return this.autoSetEmailPropertyPatterns.some(pattern => pattern.test(value.trim()));
  }

  static getLocaleStrings(locale: string) {
    try {
      const localeLang = locale.toLowerCase().substring(0, 2);
      switch (localeLang) {
        case "en":
          return locales.en;
        case "nl":
          return locales.nl;
        case "de":
          return locales.de;
        default:
          return locales.en;
      }
    } catch (error) {
      return locales.en;
    }
  }
}
